import React, { Component } from "react";
import {
	Loading,
	Button,
	Tabs,
	Tab,
	HeaderName,
	HeaderNavigation,
	SkeletonText,
	TableToolbar,
	Search,
	TextInput,
	Table,
	DatePickerInput,
	DatePicker,
	StructuredListCell,
	StructuredListBody,
	Toggle,
	ToggleSmall,
	ModalWrapper,
	StructuredListHead,
	StructuredListRow,
	Form,
	Accordion,
	AccordionItem,
	DataTable,
	StructuredListWrapper,
	TableContainer,
	TableHead,
	TableHeader,
	TableBody,
	TableRow,
	TableCell,
	Checkbox,
	FormLabel,
	FileUploader,
	RadioButtonGroup,
	FormGroup,
	MultiSelect,
	RadioButton,
	TextArea,
	TimePicker,
	TimePickerSelect,
	ComposedModal,
	ModalHeader,
	ModalBody,
	SelectItem,
	ModalFooter,
	DropdownSkeleton,////RITM0984969
} from "carbon-components-react";
import { ScrollingProvider, Section } from "../../lib/react-scroll-section/src/index";
import { Menu, Item } from "../../helpers/scrolling/ScrollingMenuItem";
import "../../scss/custom.scss";
import "../../scss/react-datetime.css";
import { switchDateFormat } from "../../helpers/jsonschemaform/customwidget/utils";
import { ComboBox } from "../../helpers/ComboBox";
import { showNotification } from "../../helpers/notification/BaseNotification";
import { getSuccess, getError, entitiesLabels, apioperation, STATUS, DateFormat } from "../../helpers/Constants";
import { api, dynamic, registry, me, training } from "../../helpers/api/api";
import { IsInRole, IsEditable, CanExecuteAction } from "../../helpers/authorization/Policies";
import { AppContext } from "../../helpers/context/AppContext";
import { CheckmarkOutline16, Send16, Delete16, Error16, Checkmark24, Information16, Add16, Edit16, CertificateCheck16, PaintBrushAlt16, Download16, Export16 } from "@carbon/icons-react/lib/";
import { WFActionModal } from "../common/WFActionModal";
import PageBreadCrumb from "../../helpers/PageBreadCrumb";
import { HistoryTable } from "../../helpers/HistoryTable";
import SimpleReactValidator from "simple-react-validator";
import { Online, Offline } from "../common/OnLineOffLine";
import moment from "moment";
import DateTimePicker from "../../helpers/DateTimePicker";
import { NoRecordsPlaceholder } from "../../helpers/jsonschemaform/DataTableExtention";
import { v4 as uuid } from "uuid";
import _sortBy from "lodash/sortBy";
import { ConfirmAlertCustom } from "../../helpers/ConfirmAlertCustom";
import ModalParticipant from "./ModalParticipant";
import ModalContent from "./ModalContent";
import ModalTrainer from "./ModalTrainer";
import ModalSignature from "./ModalSignature";

import ModalSignatureParticipant from "./ModalSignatureParticipant";
import TrainingRepository from "../../helpers/api/TrainingRepository";
import FileDownLoadButton from "../common/FileDownloadButton";
import AttachmentTable, { attachmentTablePrivacyText } from "../common/AttachmentTable";
import ConfirmModal from "../common/ConfirmModal";
import ModalTrainingCourse from "./ModalTrainingCourse";//RITM0984969
import ModalSignatureTrainer from "./ModalSignatureTrainer";//RITM0984969
import '../../scss/custom.scss';//RITM0984969

const TrainingAttachmentTableMainDescription = "Upload only one file at 3 Mb or less; please check the file attached before to submit the report because afterwards it is not possible to modify it"
export class NewTraining extends Component {
	baseUrl;
	constructor(props) {
		super(props);

		let idTraining = this.props.match.params.id;

		this.state = {
			idTraining,
			isLoadingTraining: idTraining != undefined,
			isEdit: idTraining != undefined,
			model: {
				...this.initModel(),
			},
			isSubmitted: false,
			isDisabled: false,

			invalidCertifiedDuration: false,
			///Status Action
			isLoadingNotificationFile: false,
			isApprovalModalOpen: false,
			approvalModalAction: "",
			approver: null,
			approvalStartDate: null,
			approvalEndDate: null,
			isLoadingApproverOptions: true,
			approvalValidationMessages: [],
			approvers: [],
			selectedData: [],
			approverRole: "",
			withApprover: true,
			isLoadingWFOperation: false,
			approvalNotesRequired: false,
			///Status Action
			//History WF
			isHistoryModalOpen: false,
			//History WF

			///Modal Content
			keyModalContent: `modalContent_${new Date().getTime()}`,
			isOpenModalContent: false,
			idToEditContent: null,
			idToDeleteContent: null,
			///fine Modal
			///Modal Participant
			keyModalParticipant: `modalParticipant_${new Date().getTime()}`,
			isOpenModalParticipant: false,
			idToEditParticipant: null,
			idToDeleteParticipant: null,
			///fine Modal
			///Modal Trainer
			keyModalTrainer: `modalTrainer_${new Date().getTime()}`,
			isOpenModalTrainer: false,
			idToDeleteTrainer: null,
			///fine Modal
			appReportingType: [ //RITM0984969
				{ id: 'option1', text: 'LiHS & HP' },
				{ id: 'option2', text: 'HSE' },

			],
			appReportingStyle: [ //RITM0984969
				{ id: '1', text: 'Single' },
				{ id: '2', text: 'Multiple' },

			],
			appNoOfCourses: [ //RITM0984969
				{ id: '11', text: '2' },
				{ id: '12', text: '3' },
				{ id: '13', text: '4' },
				{ id: '14', text: '5' },
				{ id: '15', text: '6' },
				{ id: '16', text: '7' },
				{ id: '17', text: '8' },
				{ id: '18', text: '9' },
				{ id: '19', text: '10' },
				{ id: '20', text: '11' },
				{ id: '21', text: '12' },
				{ id: '22', text: '13' },
				{ id: '23', text: '14' },
				{ id: '24', text: '15' },

			],
			///Modal Training Trainer //RITM0984969
			keyModalTrainingTrainer: `modalTrainer_${new Date().getTime()}`,
			isOpenModalTrainingTrainer: false,
			idToEditTrainingTrainer: null,
			idToDeleteTrainingTrainer: null,
			///fine Modal
			///Modal Training Course  //RITM0984969
			keyModalTrainingCourse: `modalContent_${new Date().getTime()}`,
			isOpenModalTrainingCourse: false,
			idToEditTrainingCourse: null,
			idToDeleteTrainingCourse: null,
			
		};

		this.baseUrl = "/training/";
		this.originalValidityDate = null;

		this.gtzValidator = {
			message: 'The value must be greater than zero and less than equal to 10',
			rule: (val) => {
				return +val > 0 && +val<=10;
			}
		};
		this.validator = new SimpleReactValidator({
			validators: { gtz: this.gtzValidator }
		});
		this.updateState = this.updateState.bind(this);
	}

	initModel = () => {
		let model = {
			//-----campi form------------
			id: uuid(), //guid
			startDate: null, //date
			endDate: null, //date
			certificateValidityMonths: null, //number
			validityDate: null, //date
			idCountry: null, //guid
			idDivision: null, //guid  division del worksite da valorizzare quando si sceglie il worksite
			idLanguage: null, //guid
			idMethod: null, //guid
			idProject: null, //guid
			idTrainingAssessmentMethod: null, //guid
			specifyOtherAssessmentMethod: null,
			idTrainingData: null, //guid
			idLihsTrainingData: null, //guid
			idWorkSite: null, //guid
			remedialActionsForFailure: null, //string
			idTrainingCenter: null, //guid
			idTrainer: null, //guid
			trainer: null, //{} TrainerDTO
			trainingContents: [], //[] TrainingContentDTO
			trainingParticipant: [], //[] TrainingParticipantDTO
			certifiedDuration: null,
			
			//-----campi di visualizzazione/sistema------------
			idCompiler: null, //guid
			idDataApprover: null, //guid
			idDivisionManager: null, //guid
			compiler: null, //string
			dataApprover: null, //string
			divisionManager: null, //string
			code: null, //string BE "TRA_1",
			progressiveId: undefined, //int BE
			sequence: undefined, //int BE
			idStatus: 0, //int
			status: null, //string "Draft",
			country: null, //string
			language: null, //string
			method: null, //string
			project: null, //string
			trainingAssessmentMethod: null, //string
			workSite: null, //string
			workflowNotes: null, //string
			info: null, //{} TrainingDataDTO solo per visualizzazione, non usato lato BE

			//download template & massive import
			downloadTemplateLoading: false,
			isImportTemplateModalOpen: false,
			//---------------------------
			reportingType: null,//RITM0984969
			reportingStyle: null,//RITM0984969
			noOfCourses: null,//RITM0984969
			trainingMethodLists: [], //RITM0984969
			trainingAssessmentMethodLists: [], //RITM0984969
			trainingTrainer: [], //RITM0984969
			trainingCourses: [], //[] TrainingCourseDTO //RITM0984969
			// RITM0562378
			attachments: [],
			idWorkSiteProject: null, //RITM1136841

			idCompany: null, //RITM0984969
			idWorkSiteGroup: null, //RITM0984969

			division: '', //solo visualizzazione RITM0984969
			workSiteGroup: '', //solo visualizzazione RITM0984969
			company: '', //solo visualizzazione RITM0984969

			ActualTrainingName: null,//RITM0984969
			
		};
		return model;
	};

	componentDidMount() {
		this.getCountry();
		this.getAllWorkSite();
		this.getAllWorkSitePrj();
		this.getTrainingData();
		this.getTrainingLanguage();
		this.getTrainingMethod();
		this.getTrainingAssessmentMethod();
		this.getTrainingCenters();
		this.getInfoOriginator();
		this.getTrainingMethodList(); //RITM0984969
		this.getTrainingAssessmentMethodList(); //RITM0984969
		this.getLihsTrainingData();//RITM0984969
		this.getTrainingenddateCutoff();//RITM0984969
		this.getWorkSiteGroup();//RITM0984969
			if(this.state.idTraining != undefined) {
			this.getTraining(this.state.idTraining);
		}
	}

	////----------handleChange----------------
	updateState = (inputName, inputValue, objName) => {
		let statusCopy = Object.assign({}, this.state[objName]);
		statusCopy[inputName] = inputValue;

		if (inputName === "certifiedDuration" && this.checkValidHours(inputValue)) this.setState({ [objName]: statusCopy, invalidCertifiedDuration: false })
		else this.setState({ [objName]: statusCopy });
		if (inputName === "reportingStyle" && inputValue === "Single") {
			statusCopy.noOfCourses = "1";
		}
		if (inputName === "reportingType" && inputValue === "LiHS & HP") {
			statusCopy.reportingStyle = "Single";
			statusCopy.noOfCourses = "1";
		}
		else this.setState({ [objName]: statusCopy });
		//if (inputName === "noOfCourses" ) {
			
		//	statusCopy.noOfCourses = parseInt(inputValue);
		//	this.setState({ [objName]: statusCopy })
		//}
	};

	handleChangeCertificateValidityPeriod = (e) => {
		const isEmptyOrWhiteSpace = (str) => {
			return str == null || str.match(/^ *$/) !== null;
		};
		const rawValue = e.target.value;
		const value = isEmptyOrWhiteSpace(rawValue) ? null : parseInt(rawValue);
		if (isNaN(value)) return;
		this.setState(prevState => {
			let modelCopy = { ...prevState.model };
			modelCopy.certificateValidityMonths = value;
			modelCopy.validityDate = value == null
				? this.originalValidityDate
				: moment(modelCopy.endDate)
					.add(value, 'year')
					.format("YYYY-MM-DD");
			return {
				model: modelCopy
			};
		});
	};

	handleChangeModel = (el) => {
		let inputName = el.target.name;
		let inputValue = el.target.value;
		let objName = el.target.alt;
		this.updateState(inputName, inputValue, objName);
	};

	handleChangeDate = (inputName, inputValue, objName) => {
		
			let statusCopy = Object.assign({}, this.state[objName]);
		statusCopy[inputName] = inputValue;
		
		    statusCopy.idWorkSite = null;
			statusCopy.workSite = null;
			statusCopy.idDivision = null;
			statusCopy.idProject = null;
			statusCopy.project = null;
			statusCopy.idTrainingData = null
			statusCopy.info = null
			statusCopy.certifiedDuration = null
			statusCopy.idLihsTrainingData = null
			statusCopy.lihsInfo = null

			this.setState({ [objName]: statusCopy });
	};

	handleChangeCombo = (inputName, selectedItem, objName) => {
		let inputValue = selectedItem ? selectedItem.id : null;

		let statusCopy = Object.assign({}, this.state[objName]);
		statusCopy[inputName] = inputValue;

		if (inputName == "idWorkSite") {
			statusCopy.workSite = selectedItem ? selectedItem.name : null;
			statusCopy.idDivision = selectedItem ? selectedItem.idDivision : null;
			statusCopy.idProject = null;
			statusCopy.project = null;
			//devOps 639
			statusCopy.idCountry = null;
			statusCopy.country = null;
			statusCopy.idWorkSiteProject = null; //RITM1136841

		}

		if (inputName == "idProject") {
			statusCopy.project = selectedItem ? selectedItem.name : null;
			//devOps 639
			statusCopy.idCountry = selectedItem ? selectedItem.idCountry : null
			statusCopy.country = this.state.appCountry.find(el => el.id === selectedItem?.idCountry)?.name ?? null
			statusCopy.idWorkSiteProject = selectedItem ? selectedItem.idWorksitePrj : null //RITM1136841
			//RITM0984969 start
			if (selectedItem) {

				let wksprj = this.state.appAllWorksitePrj.find((el) => el.id == selectedItem.idWorksitePrj);

				statusCopy.idWorkSiteProject = wksprj.id;
				statusCopy.idDivision = wksprj.idDivision;
				statusCopy.idCompany = wksprj.idCompany;

				statusCopy.division = wksprj.division;
				
				statusCopy.company = wksprj.company;
				let wks = wksprj!=null ? this.state.appAllWorksites.find((el) => el.id == wksprj?.idWorkSite):null;
				statusCopy.idWorkSiteGroup = wks.idWorkSiteGroup;
				
				let wksgrp = wks != null ? this.state.appWorkSiteGroup.find((el) => el.value == wks?.idWorkSiteGroup) : null;
				statusCopy.workSiteGroup = wksgrp != null ? wksgrp.label : null;

			} else {
				statusCopy.project = null;
				statusCopy.idCountry = null
				statusCopy.country = this.state.appCountry.find(el => el.id === selectedItem?.idCountry)?.name ?? null
				statusCopy.idWorkSiteProject = null;
				statusCopy.idDivision = null;
				statusCopy.idCompany = null;
				statusCopy.division = '';
				
				statusCopy.company = '';

				statusCopy.idWorkSiteGroup = null;
				statusCopy.workSiteGroup = '';

			}
			////RITM0984969 end
		}

		if (inputName == "idTrainingData") {
			statusCopy.info = selectedItem;
			//statusCopy.certifiedDuration = selectedItem?.duration;
			statusCopy.lihsInfo = null;
		}
		if (inputName == "idLihsTrainingData") {
			statusCopy.lihsInfo = selectedItem;
			//statusCopy.certifiedDuration = selectedItem?.duration;
			statusCopy.info = null;
		}
		if (inputName == "idLanguage") {
			statusCopy.language = selectedItem ? selectedItem.name : null;
		}
		if (inputName == "idCountry") {
			statusCopy.country = selectedItem ? selectedItem.name : null;
		}
		if (inputName == "idMethod") {
			statusCopy.method = selectedItem ? selectedItem.name : null;
		}
		if (inputName == "idTrainingAssessmentMethod") {
			statusCopy.trainingAssessmentMethod = selectedItem ? selectedItem.name : null;
		}

		this.setState({ [objName]: statusCopy });
	};

	//RITM0984969
	handleSpecifyOtherTrainingAssessmentMethod = (el) => {
		let inputValue = el.target.value;
		let objName = el.target.alt;
		this.updateStateTAML("specifyOther", inputValue, objName, "trainingAssessmentMethodLists");
	};

	onChangeTM = (selectedItem) => {
		const items = selectedItem ? selectedItem.selectedItems : null;
		const element = items?.map((elem) => ({ trainingMethod: elem, idTrainingMethod: elem.id })) || []
		this.updateStateTML("trainingMethodLists", element, "model", null)
	};

	updateStateTML = (inputName, inputValue, objName, parentObjName) => {
		let statusCopy = Object.assign({}, this.state);
		let oldOthers = {};
		let newOthers = {};
		let woNewOthers = [];
		if (inputName == 'trainingMethodLists') {
			newOthers = inputValue?.find(el => el?.trainingMethod?.name?.toLowerCase() === 'other (specify)') || {};
			woNewOthers = inputValue?.filter(el => el?.trainingMethod?.name?.toLowerCase() !== 'other (specify)') || inputValue;
			if (statusCopy[objName][inputName] !== undefined)
				oldOthers = statusCopy[objName][inputName].find(el => el.trainingMethod.name.toLowerCase() === 'other (specify)') || {};
			statusCopy[objName][inputName] = [...woNewOthers];
			if (Object.keys(oldOthers).length !== 0 && Object.keys(newOthers).length !== 0)
				statusCopy[objName][inputName].push(oldOthers);
			else if (Object.keys(oldOthers).length === 0 && Object.keys(newOthers).length !== 0)
				statusCopy[objName][inputName].push(newOthers);
		}


		this.setState({ statusCopy });
	}

	onChangeTAM = (selectedItem) => {
		const items = selectedItem ? selectedItem.selectedItems : null;
		const element = items?.map((elem) => ({ trainingAssessmentMethod: elem, idTrainingAssessmentMethod: elem.id })) || []
		this.updateStateTAML("trainingAssessmentMethodLists", element, "model", null)
	};

	updateStateTAML = (inputName, inputValue, objName, parentObjName) => {
		let statusCopy = Object.assign({}, this.state);
		let oldOthers = {};
		let newOthers = {};
		let woNewOthers = [];
		if (inputName == 'trainingAssessmentMethodLists') {
			newOthers = inputValue?.find(el => el?.trainingAssessmentMethod?.name?.toLowerCase() === 'other (specify)') || {};
			woNewOthers = inputValue?.filter(el => el?.trainingAssessmentMethod?.name?.toLowerCase() !== 'other (specify)') || inputValue;
			if (statusCopy[objName][inputName] !== undefined)
				oldOthers = statusCopy[objName][inputName].find(el => el.trainingAssessmentMethod.name.toLowerCase() === 'other (specify)') || {};
			statusCopy[objName][inputName] = [...woNewOthers];
			if (Object.keys(oldOthers).length !== 0 && Object.keys(newOthers).length !== 0)
				statusCopy[objName][inputName].push(oldOthers);
			else if (Object.keys(oldOthers).length === 0 && Object.keys(newOthers).length !== 0)
				statusCopy[objName][inputName].push(newOthers);
		}
		if (inputName == 'specifyOther') {
			oldOthers = statusCopy[objName][parentObjName].find(el => el.trainingAssessmentMethod.name.toLowerCase() === 'other (specify)') || {};
			if (Object.keys(oldOthers).length !== 0)
				oldOthers[inputName] = inputValue;
		}

		this.setState({ statusCopy });
	}


	////----------Fine handleChange----------------

	showLoading() {
		let show = (this.state.isEdit && this.state.isLoadingTraining) || this.state.isSubmitted;
		let descr = this.state.isSubmitted ? "Saving..." : "Loading data...";
		return show && <Loading active={true} withOverlay={true} description={descr} />;
	}

	showButtonHistory = () => {
		return (
			<Online>
				<Button className="action-button-modal" kind="secondary" renderIcon={Information16} onClick={() => this.openModalHistory()}>
					History
				</Button>
			</Online>
		);
	};

	openModalHistory = () => {
		this.setState({ isHistoryModalOpen: true });
	};

	closeModalHistory = () => {
		this.setState({ isHistoryModalOpen: false });
	};

	cancel = () => {
		this.props.history.push("/training");
	};

	toggleModal = (open, property) => {
		this.setState({ [property]: open });
	};

	getPrj = (idWorkSite, start, end) => {
		try {
			let data = (this.state.appAllWorksitePrj || []).filter((el) => el.idWorkSite == idWorkSite);

			if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(start) && /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(end)) {
				data = (data || []).filter((el) => el.start <= start && end <= el.end);
				return _sortBy(
					data.map((item) => ({ id: item.idProject, name: item.project, idWorksitePrj: item.id, /*devOps 639*/ idCountry: item.idCountry })),
					"name"
				);
			} else {
				return null;
			}
		} catch {
			showNotification.error(`${entitiesLabels.ERROR}`, "Error filtering " + entitiesLabels.WORKSITEPROJECT);
			return null;
		}
	};

	getWorkSite = (start, end) => {
		try {
			let data = this.state.appAllWorksites;

			if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(start) && /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(end)) {
				return _sortBy((data || []).filter((el) => el.start <= start && end <= el.end), "name"
				);
			} else {
				return null;
			}
		} catch {
			showNotification.error(`${entitiesLabels.ERROR}`, "Error filtering " + entitiesLabels.WORKSITE);
			return null;
		}
	};



	////----------API----------------
	getAllWorkSite() {
		api.getAll("/me/worksites")
			.then((response) => {
				let data = response.data;
				this.setState({
					appAllWorksites: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITE, apioperation.GET));
			})
			.finally(() => { });
	}

	getAllWorkSitePrj() {
		api.getAll("/me/worksitesproject")
			.then((response) => {
				let data = response.data;
				this.setState({
					appAllWorksitePrj: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITEPROJECT, apioperation.GET));
			})
			.finally(() => { });
	}

	getInfoOriginator = () => {
		dynamic
			.getAll("infooriginator", { params: { page: 0 } }) //RITM1197573
			.then((response) => {
				let data = _sortBy(response.data.itemList, "id").filter(item => item.name != "Saipem"); //RITM1197573
				data = data != null ? data.map((item) => ({ id: item.name, name: item.name, inUse: item.inUse })) : []; //RITM1197573
				this.setState({
					appInfoOriginator: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INFOORIGINATOR, apioperation.GET));
			})
			.finally(() => { });
	};

	getCountry = () => {
		api.getAll("/country")
			.then((response) => {
				let data = response.data;
				this.setState({
					appCountry: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.COUNTRY, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingCountry: false,
				});
			});
	};
	getWorkSiteGroup() { //RITM0984969
		this.setState({ isLoadingWorkSiteGroup: true });

		dynamic
			.getAll('worksitegroup', { params: { page: 0 } })
			.then((response) => {
				var data = response.data.itemList;

				data = data != null ? data.map((item) => ({ value: item.id, label: item.name })) : [];
				this.setState({
					appWorkSiteGroup: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITEGROUP, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingWorkSiteGroup: false,
				});
			});
	}

	returnValidTrainingData = (itemList) => {
		if (itemList) {
			// return  itemList.filter((el) => el.inUse);
			const selectedStartDate = new Date(this.state.model.startDate)
			const startedTrainings = itemList.filter((el) => (el.validSince ? new Date(el.validSince) <= selectedStartDate : true)) ?? [];
			const startedNotExpired = startedTrainings.filter((el) => (el.validUntil ? new Date(el.validUntil) >= selectedStartDate : true)) ?? [];

			return startedNotExpired
		}
		return [];
	};
	returnValidLihsTrainingData = (itemList) => {
		if (itemList) {
			// return  itemList.filter((el) => el.inUse);
			const selectedStartDate = new Date(this.state.model.startDate)
			const startedTrainings = itemList.filter((el) => (el.validSince ? new Date(el.validSince) <= selectedStartDate : true)) ?? [];
			const startedNotExpired = startedTrainings.filter((el) => (el.validUntil ? new Date(el.validUntil) >= selectedStartDate : true)) ?? [];

			return startedNotExpired
		}
		return [];
	};
	getTrainingData = () => {
		dynamic
			.getAll("trainingdata", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList;
				this.setState({
					appTrainingData: _sortBy(data, "courseCode"),
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGDATA, apioperation.GET));
			})
			.finally(() => { });
	};

	getLihsTrainingData = () => { //RITM0984969
		dynamic
			.getAll("LIHStrainingdata", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList;
				this.setState({
					appLihsTrainingData: _sortBy(data, "courseCode"),
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.LIHSTRAININGDATA, apioperation.GET));
			})
			.finally(() => { });
	};

	getTrainingLanguage = () => {
		dynamic
			.getAll("traininglanguage", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList;
				this.setState({
					appLanguage: data,
					//devOps 638
					model: {
						...this.state.model,
						idLanguage: this.state.idTraining != undefined ? this.state.model.idLanguage : data.find(el => el.code.toUpperCase() === "ENGLISH")?.id ?? null
					}
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGLANGUAGE, apioperation.GET));
			})
			.finally(() => { });
	};

	getTrainingMethod = () => {
		dynamic
			.getAll("trainingmethod", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList;
				this.setState({
					appMethod: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGMETHOD, apioperation.GET));
			})
			.finally(() => { });
	};
	getTrainingMethodList = () => {//RITM0984969
		dynamic
			.getAll("trainingmethod", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList.filter(item => item.inUse === true);
				this.setState({ appTrainingMethodList: data });
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGMETHOD, apioperation.GET));
			})
			.finally(() => { });
	};

	getTrainingAssessmentMethod = () => {
		dynamic
			.getAll("trainingassessmentmethod", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList;
				this.setState({
					appAssessmentMethod: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGASSESSMENTMETHOD, apioperation.GET));
			})
			.finally(() => { });
	};

	getTrainingAssessmentMethodList = () => {//RITM0984969
		dynamic
			.getAll("trainingassessmentmethod", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList.filter(item => item.inUse === true);
				this.setState({ appTrainingAssessmentMethodList: data });
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGASSESSMENTMETHOD, apioperation.GET));
			})
			.finally(() => { });
	};

	getTrainingCenters = () => {
		dynamic
			.getAll("trainingcenter", { params: { page: 0 } })
			.then((response) => {
				let data = response.data.itemList.filter(item => item.inUse === true); //RITM0837173
				this.setState({ appTrainingCenters: data });
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGCENTER, apioperation.GET));
			})
			.finally(() => { });
	};
	getTrainingenddateCutoff = () => { //RITM0984969
		dynamic
			.getAll("trainingreportingdate", { params: { page: 0 } })
			.then((response) => {
				
				let data = response.data.itemList.filter(item => item.inUse === true);
				this.setState({ appTrainingEnddateCutoff: data });
				
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGCENTER, apioperation.GET));
			})
			.finally(() => { });
	};
	getTraining(id) {
		this.setState({
			isEdit: true,
			isLoadingTraining: true,
		});

		api.get(this.baseUrl, id)
			.then((response) => {
				let data = response.data;
				if (data) {

					this.originalValidityDate = data.validityDate ?? null;
					this.setState({
						model: data,
						isDisabled: data ? !IsEditable("Training", "Reporting", this.context.user, data.idStatus, "All", data) : false,
					});
				} else {
					showNotification.error();
					this.cancel();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.GET));

				this.cancel();
			})
			.finally(() => {
				this.setState({
					isLoadingTraining: false,
				});
			});
	}
	saveTraining = () => {
		
		const trainingStartDate = moment(this.state.model.startDate);
		const trainingEndDate = moment(this.state.model.endDate);
	
		const diffDuration = trainingEndDate.diff(trainingStartDate, 'days')+1;
		const diffDurationInHours = diffDuration * 10;
		
	
		const checkValidDuration = !this.state.isEdit ? true : this.checkValidHours(this.state.model.certifiedDuration) && (this.state.model.certifiedDuration <= diffDurationInHours);
		const validNoOfCourses = this.state.isEdit ? true : this.checkNoOfCourses();
		const isLeadTrainerPresent = this.state.model.trainingTrainer!=null?(this.state.model.trainingTrainer.length==1?true:
		(this.state.model.trainingTrainer.length > 1 
				&& this.state.model.trainingTrainer.filter((el) => el.leadTrainer == true).length == 1 ? true : false)) : false;
		
		var startdateYear = this.state.model.startDate != null ? moment(this.state.model.startDate).format('YYYY') : null;
		var enddateYear = this.state.model.endDate != null ? moment(this.state.model.endDate).format('YYYY') : null;

		let enddateCutoff = this.state.appTrainingEnddateCutoff != null ? this.state.appTrainingEnddateCutoff.find((e1) => e1.year == startdateYear)?.reportingEndDate:null;
		const trainingEnddateCutoff = enddateCutoff != null && enddateCutoff != undefined ? moment(enddateCutoff) : moment(new Date(startdateYear, 11, 31));

		
		let result = trainingEnddateCutoff.diff(trainingEndDate, 'days');
		const diffCutOffEndDate = (trainingEnddateCutoff != null) ? trainingEnddateCutoff.diff(trainingEndDate, 'days') : 0;
	

		const isWithinCutOffDate = diffCutOffEndDate >= 0 ? true : false;

		
		if (this.validator.allValid() && validNoOfCourses && isLeadTrainerPresent && checkValidDuration && (diffDuration <= 30) && isWithinCutOffDate) {

			this.toggleModal(true, "isSubmitted");
			let datiForm = this.state.model;
			
			//if (!this.state.isEdit) { datiForm.id = uuid() } //spostato in initModel
			let method = this.state.isEdit ? api.put(this.baseUrl, datiForm, datiForm.id) : api.post(this.baseUrl, datiForm);

			method
				.then((response) => {

					if (response.status == 200) {
						let resp = response.data;

						showNotification.success(`${entitiesLabels.SUCCESS}`, this.state.isEdit ? getSuccess(entitiesLabels.TRAINING, apioperation.PUT) : getSuccess(entitiesLabels.TRAINING, apioperation.POST));

						if (!this.state.isEdit) {
							//aggiornare il modello dati con le props mancanti
							datiForm["idCompiler"] = this.context.user.id;
							datiForm["compiler"] = this.context.user.email;
							datiForm["idStatus"] = 1;
							datiForm["status"] = "Draft";

						}

						//update new default validity date
						this.originalValidityDate = this.state.model.validityDate;

						//update state partecipants for enable signature
						if (datiForm.trainingParticipant && datiForm.trainingParticipant.length) {
							let newtrainingParticipants = [...datiForm.trainingParticipant];
							newtrainingParticipants.forEach(function (obj) {
								if (obj.toSave) {
									obj.toSave = false;
								}
							});
							this.updateState("trainingParticipant", newtrainingParticipants, "model");
						}
					
						this.updateCacheTrainingModel(datiForm);
					} else {
						showNotification.error();
					}
				})
				.catch((error) => {
					console.log(error)
					showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.POST));
				})
				.finally(() => {
					this.toggleModal(false, "isSubmitted");
				});

		} else {
			if (!this.validator.allValid()) {
				this.validator.showMessages();
				showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.TRAINING + " required fields are missing  ");
			}
			if (!validNoOfCourses) {

				showNotification.warning(`No of courses is not matching`, "Number of courses added must be equal to No of Courses conducted")
			}
			if (!isLeadTrainerPresent) {

				showNotification.warning(`Enter only one lead trainer in Training`, "Please remember to add only one lead trainer in Training")
			}
			if (!checkValidDuration) {
				showNotification.warning(`Certified Duration Not Valid`, "Duration (hours) should not exceed 10 hours per day or Duration (hours) should be between max duration & min duration or Only integer or decimal values ​​greater than 0 and with a scale of 0.5 are allowed")
			}
			if (diffDuration > 30) {
				showNotification.warning(`End Date Not Valid`, "Allow End date only for a period of 30 days from Start Date")
			}
			if (!isWithinCutOffDate)
			{
				showNotification.warning(`End Date Not Valid`, "The selected start or end dates are outside the permissible reporting period. Please choose a date within the current year.")
			}
			
			this.forceUpdate();
		}
	};
	

	updateCacheTrainingModel = async (datiForm) => {
		await Promise.all([TrainingRepository.updateCachedTrainingList(datiForm), TrainingRepository.updateCachedTraining(datiForm.id, datiForm)])
			.then((response) => {
				if (!this.state.isEdit) {
					this.props.history.push("/training/");
				}
			})
			.catch((error) => {
				console.error({ error });
			})
			.finally(() => { });
	};

	////----------Fine API----------------
	/**************Training Course**********************/

	addTrainingCourse = () => {
		this.setState({
			isOpenModalTrainingCourse: true,
			idToEditTrainingCourse: null,
			keyModalTrainingCourse: `modalTrainingCourse_${new Date().getTime()}`,
		});
	};

	editTrainingCourse = (id) => {
		this.setState({
			isOpenModalTrainingCourse: true,
			idToEditTrainingCourse: id,
			keyModalTrainingCourse: `modalTrainingCourse_${new Date().getTime()}`,
		});
	};

	handleSaveModalTrainingCourse = (data) => {
		try {
			if (data == null) return;


			let oldtrainingCourses = this.state.model.trainingCourses || [];

			if (this.state.idToEditTrainingCourse != null) {
				//edit
				let id = data.id;
				let indexElement = oldtrainingCourses.findIndex((el) => el.id == id);
				if (indexElement > -1) {
					let newtrainingCourses = [...oldtrainingCourses];

					newtrainingCourses[indexElement].idTrainingData = data.idTrainingData;
					newtrainingCourses[indexElement].idLihsTrainingData = data.idLihsTrainingData;
					newtrainingCourses[indexElement].idLanguage = data.idLanguage;
					newtrainingCourses[indexElement].info = data.info;
					newtrainingCourses[indexElement].lihsInfo = data.lihsInfo;
					newtrainingCourses[indexElement].Language = data.Language;
					if (data.info?.actualTrainingName == true || data.lihsInfo?.actualTrainingName == true) {
						newtrainingCourses[indexElement].actualTrainingName = data.actualTrainingName;
					}
					newtrainingCourses[indexElement].certifiedDuration = data.certifiedDuration;
					newtrainingCourses[indexElement].certificateValidityMonths = data.certificateValidityMonths;
					newtrainingCourses[indexElement].validityDate = data.validityDate;
					newtrainingCourses[indexElement].trainingMethodLists = data.trainingMethodLists;
					newtrainingCourses[indexElement].trainingAssessmentMethodLists = data.trainingAssessmentMethodLists;

					this.updateState("trainingCourses", newtrainingCourses, "model");
				} else {
					showNotification.error();
				}
			} else {
				//insert
				data.id = uuid();
				data.createdOn = moment.utc().format();
				data.createdBy = this.context.user.email;
				data.toSave = true;
				let newtrainingCourses = oldtrainingCourses.concat([data]);
			
				this.updateState("trainingCourses", newtrainingCourses, "model");
				this.setState({
					search: null,
				});
			}

			this.setState({ isOpenModalTrainingCourse: false });


		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.POST));
		}
	};


	confirmDeleteTrainingCourse = (id) => {
		this.setState({
			idToDeleteContent: null,
			idToDeleteTrainingTrainer: null,
			idToDeleteParticipant: null,
			idToDeleteTrainingCourse: id,
			isOpenDeleteModal: true,
			isDeleting: false,
		});
	};

	deleteItemTrainingCourse = () => {
		let id = this.state.idToDeleteTrainingCourse;
		this.setState({
			isDeleting: true,
		});

		let statusCopy = Object.assign({}, this.state.model);
		statusCopy.trainingCourses = statusCopy.trainingCourses.filter((el) => el.id !== id);

		this.setState({
			model: statusCopy,
			isDeleting: false,
			isOpenDeleteModal: false,
		});
	};
	/**************Training Course**********************/
	/**************Contents**********************/

	addContent = () => {
		this.setState({
			isOpenModalContent: true,
			idToEditContent: null,
			keyModalContent: `modalContent_${new Date().getTime()}`,
		});
	};

	editContent = (id) => {
		this.setState({
			isOpenModalContent: true,
			idToEditContent: id,
			keyModalContent: `modalContent_${new Date().getTime()}`,
		});
	};

	handleSaveModalContent = (data) => {
		try {
			if (data == null) return;

			let oldtrainingContents = this.state.model.trainingContents || [];

			if (this.state.idToEditContent != null) {
				//edit
				let id = data.id;
				let indexElement = oldtrainingContents.findIndex((el) => el.id == id);
				if (indexElement > -1) {
					let newtrainingContents = [...oldtrainingContents];
					newtrainingContents[indexElement] = data;
					this.updateState("trainingContents", newtrainingContents, "model");
				} else {
					showNotification.error();
				}
			} else {
				//insert
				data.id = uuid();
				data.TrainingId = this.state.model.id; //RITM0984969
				data.createdOn = moment.utc().format();
				data.createdBy = this.context.user.email;
				let newtrainingContents = oldtrainingContents.concat([data]);
				this.updateState("trainingContents", newtrainingContents, "model");
			}

			this.setState({ isOpenModalContent: false });
		} catch (error) {
			showNotification.error();
		}
	};

	confirmDeleteContent = (id) => {
		this.setState({
			idToDeleteParticipant: null,
			idToDeleteTrainer: null,
			idToDeleteContent: id,
			isOpenDeleteModal: true,
			isDeleting: false,
		});
	};

	deleteItemContent = () => {
		let id = this.state.idToDeleteContent;
		this.setState({
			isDeleting: true,
		});

		let statusCopy = Object.assign({}, this.state.model);
		statusCopy.trainingContents = statusCopy.trainingContents.filter((el) => el.id !== id);

		this.setState({
			model: statusCopy,
			isDeleting: false,
			isOpenDeleteModal: false,
		});
	};

	/**************Fine Contents**********************/
	/**************Participants**********************/

	addParticipant = () => {
		this.setState({
			isOpenModalParticipant: true,
			idToEditParticipant: null,
			keyModalParticipant: `modalParticipant_${new Date().getTime()}`,
		});
	};

	editParticipant = (id) => {
		this.setState({
			isOpenModalParticipant: true,
			idToEditParticipant: id,
			keyModalParticipant: `modalParticipant_${new Date().getTime()}`,
		});
	};

	handleSaveModalParticipant = (data) => {
		try {
			if (data == null) return;

			let oldtrainingParticipants = this.state.model.trainingParticipant || [];

			if (this.state.idToEditParticipant != null) {
				//edit
				let id = data.id;
				let indexElement = oldtrainingParticipants.findIndex((el) => el.id == id);
				if (indexElement > -1) {
					let newtrainingParticipants = [...oldtrainingParticipants];
					//newtrainingParticipants[indexElement] = data;
					newtrainingParticipants[indexElement].type = data.type;
					newtrainingParticipants[indexElement].name = data.name;
					newtrainingParticipants[indexElement].surname = data.surname;
					newtrainingParticipants[indexElement].email = data.email;
					newtrainingParticipants[indexElement].position = data.position;
					newtrainingParticipants[indexElement].badgeNumber = data.badgeNumber;
					newtrainingParticipants[indexElement].birthDate = data.birthDate;
					newtrainingParticipants[indexElement].idEmployer = data.idEmployer;
					newtrainingParticipants[indexElement].idWorkSite = data.idWorkSite;
					newtrainingParticipants[indexElement].idProject = data.idProject;
					newtrainingParticipants[indexElement].workSite = data.workSite;
					newtrainingParticipants[indexElement].project = data.project;
					this.updateState("trainingParticipant", newtrainingParticipants, "model");
				} else {
					showNotification.error();
				}
			} else {
				//insert
				data.id = uuid();
				data.idTraining = this.state.model.id;
				data.createdOn = moment.utc().format();
				data.createdBy = this.context.user.email;
				data.toSave = true;
				let newtrainingParticipants = oldtrainingParticipants.concat([data]);
				this.updateState("trainingParticipant", newtrainingParticipants, "model");
				this.setState({
					search: null,
				});
			}

			this.setState({ isOpenModalParticipant: false });
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.POST));
		}
	};

	confirmDeleteParticipant = (id) => {
		this.setState({
			idToDeleteContent: null,
			idToDeleteTrainer: null,
			idToDeleteParticipant: id,
			isOpenDeleteModal: true,
			isDeleting: false,
		});
	};

	deleteItemParticipant = () => {
		let id = this.state.idToDeleteParticipant;
		this.setState({
			isDeleting: true,
		});

		let statusCopy = Object.assign({}, this.state.model);
		statusCopy.trainingParticipant = statusCopy.trainingParticipant.filter((el) => el.id !== id);

		this.setState({
			model: statusCopy,
			isDeleting: false,
			isOpenDeleteModal: false,
		});
	};

	/**************Fine Participants**********************/
	/**************Training Trainers**********************/

	addTrainingTrainer = () => {
		this.setState({
			isOpenModalTrainingTrainer: true,
			idToEditTrainingTrainer: null,
			keyModalTrainingTrainer: `modalTrainer_${new Date().getTime()}`,
		});
	};

	editTrainingTrainer = (id) => {
		this.setState({
			isOpenModalTrainingTrainer: true,
			idToEditTrainingTrainer: id,
			keyModalTrainingTrainer: `modalTrainer_${new Date().getTime()}`,
		});
	};

	handleSaveModalTrainingTrainer = (data) => {
		try {
			if (data == null) return;

			let oldtrainingTrainers = this.state.model.trainingTrainer || [];
			//let trainingParticipants = this.state.model.trainingParticipant || [];
			//let trainerFoundInParicipantList = trainingParticipants.this.props.participants.find((el) => (el.name.toLowerCase() + ' ' + el.surname.toLowerCase() == data.name.toLowerCase() + ' ' + data.surname.toLowerCase()) && el.type == data.type) ? true : false;
			//if (trainerFoundInParicipantList) {
			//	showNotification.warning(`${entitiesLabels.WARNING}`, 'Trainer is already present in participant list of the training');
			//	return;
			//}
			/*else {*/
			if (this.state.idToEditTrainingTrainer != null) {
				//edit
				let id = data.id;
				let indexElement = oldtrainingTrainers.findIndex((el) => el.id == id);
				if (indexElement > -1) {
					let newtrainingTrainers = [...oldtrainingTrainers];

					newtrainingTrainers[indexElement].type = data.type;
					newtrainingTrainers[indexElement].name = data.name;
					newtrainingTrainers[indexElement].surname = data.surname;
					newtrainingTrainers[indexElement].email = data.email;
					newtrainingTrainers[indexElement].organization = data.organization;
					newtrainingTrainers[indexElement].badgeNumber = data.badgeNumber;
					newtrainingTrainers[indexElement].birthDate = data.birthDate;
					newtrainingTrainers[indexElement].idEmployer = data.idEmployer;
					newtrainingTrainers[indexElement].title = data.title;
					newtrainingTrainers[indexElement].leadTrainer = data.leadTrainer;
					this.updateState("trainingTrainer", newtrainingTrainers, "model");
				} else {
					showNotification.error();
				}
			} else {
				//insert
				data.id = uuid();
				data.idTraining = this.state.model.id;
				data.createdOn = moment.utc().format();
				data.createdBy = this.context.user.email;
				data.toSave = true;
				let newtrainingTrainers = oldtrainingTrainers.concat([data]);
				this.updateState("trainingTrainer", newtrainingTrainers, "model");
				this.setState({
					search: null,
				});
			}
			//}
			this.setState({ isOpenModalTrainingTrainer: false });
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.POST));
		}

	};

	confirmDeleteTrainingTrainer = (id) => {
		this.setState({
			idToDeleteContent: null,
			idToDeleteTrainingTrainer: id,
			idToDeleteParticipant: null,
			isOpenDeleteModal: true,
			isDeleting: false,
		});
	};

	deleteItemTrainingTrainer = () => {
		let id = this.state.idToDeleteTrainingTrainer;
		this.setState({
			isDeleting: true,
		});

		let statusCopy = Object.assign({}, this.state.model);
		statusCopy.trainingTrainer = statusCopy.trainingTrainer.filter((el) => el.id !== id);

		this.setState({
			model: statusCopy,
			isDeleting: false,
			isOpenDeleteModal: false,
		});
	};

	/**************Fine **********************/
	/**************Trainer**********************/

	editTrainer = () => {
		this.setState({
			isOpenModalTrainer: true,
			keyModalTrainer: `modalTrainer_${new Date().getTime()}`,
		});

	};

	handleSaveModalTrainer = (data) => {
		try {
			if (data == null) return;

			if (!this.state.model.trainer) {
				//insert
				data.id = uuid();
				data.createdOn = moment.utc().format();
				data.createdBy = this.context.user.email;
			}

			let statusCopy = Object.assign({}, this.state.model);
			statusCopy.idTrainer = data.id;
			statusCopy.trainer = { ...statusCopy.trainer, ...data };
			statusCopy.trainer.updatedOn = moment.utc().format();
			statusCopy.trainer.updatedBy = this.context.user.email;

			this.setState({
				model: statusCopy,
				isOpenModalTrainer: false,
			});
		} catch (error) {
			showNotification.error();
		}
	};

	confirmDeleteTrainer = (id) => {
		this.setState({
			idToDeleteContent: null,
			idToDeleteParticipant: null,
			idToDeleteTrainer: id,
			isOpenDeleteModal: true,
			isDeleting: false,
		});
	};

	deleteItemTrainer = () => {
		let id = this.state.idToDeleteTrainer;
		this.setState({
			isDeleting: true,
		});

		let statusCopy = Object.assign({}, this.state.model);
		statusCopy.idTrainer = null;
		statusCopy.trainer = null;

		this.setState({
			model: statusCopy,
			isDeleting: false,
			isOpenDeleteModal: false,
		});
	};

	/**************Fine Trainer**********************/
	/**************TrainerSign**********************/

	editTrainerSign = () => {
		this.setState({
			isOpenModalTrainerSign: true,
			keyModalTrainerSign: `modalTrainerSign_${new Date().getTime()}`,
		});
	};

	handleSaveModalTrainerSign = (data) => {
		try {
			if (data == null) return;

			if (this.state.model.trainer) {
				let statusCopy = Object.assign({}, this.state.model);
				statusCopy.trainer.signatureAttachment = data;
				this.setState({
					model: statusCopy,
					isOpenModalTrainerSign: false,
				});
			}
		} catch (error) {
			showNotification.error();
		}
	};
	editTrainersSign = (id) => { //RITM0984969
		this.setState({
			isOpenModalTrainersSign: true,
			idToEditTrainersSign: id,
			keyModalTrainersSign: `modalTrainerSign_${new Date().getTime()}`,
		});
	};

	handleSaveModalTrainersSign = (data) => {//RITM0984969
		try {
			if (data == null) return;

			let oldtrainingTrainers = this.state.model.trainingTrainer || [];
			let id = data.id;

			let indexElement = oldtrainingTrainers.findIndex((el) => el.id == id);
			if (indexElement > -1) {
				let newtrainingTrainers = [...oldtrainingTrainers];

				newtrainingTrainers[indexElement].signatureAttachment = data.signatureAttachment;

				let statusCopy = Object.assign({}, this.state.model);
				statusCopy.trainingTrainer = newtrainingTrainers;
				this.setState({
					model: statusCopy,
					isOpenModalTrainersSign: false,
				});
			} else {
				showNotification.error();
			}
		} catch (error) {
			showNotification.error();
		}
	};
	/**************Fine TrainerSign**********************/
	/**************ParticipantsSign**********************/

	editParticipantsSign = (id) => {
		this.setState({
			isOpenModalParticipantsSign: true,
			idToEditParticipantsSign: id,
			keyModalParticipantsSign: `modalParticipantsSign_${new Date().getTime()}`,
		});
	};

	handleSaveModalParticipantsSign = (data) => {
		try {
			if (data == null) return;

			let oldtrainingParticipants = this.state.model.trainingParticipant || [];
			let id = data.id;
			let indexElement = oldtrainingParticipants.findIndex((el) => el.id == id);
			if (indexElement > -1) {
				let newtrainingParticipants = [...oldtrainingParticipants];

				newtrainingParticipants[indexElement].knowledgeAssessment = data.knowledgeAssessment;
				newtrainingParticipants[indexElement].note = data.note;
				newtrainingParticipants[indexElement].signatureAttachment = data.signatureAttachment;

				let statusCopy = Object.assign({}, this.state.model);
				statusCopy.trainingParticipant = newtrainingParticipants;
				this.setState({
					model: statusCopy,
					isOpenModalParticipantsSign: false,
				});
			} else {
				showNotification.error();
			}
		} catch (error) {
			showNotification.error();
		}
	};
	/**************Fine ParticipantsSign**********************/

	handleInputChange = (e) => {
		let val = e.target.value;
		this.setState({
			search: val,
		});
	};

	///WF
	handleApproverSelect = (selectedItem) => {
		this.setState({ approver: selectedItem });
	};
	handleCloseApprovalModal = () => {
		this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
	};
	handleApprovalNotesChange = (e) => {
		this.setState({ approvalNotes: e.target.value });
	};
	IsRowSelectable() {
		var row = this.state.model;
		if (row == null || row.idStatus == STATUS.Consolidated) return false;

		return true;
	}

	getUsersInRole = (role, idEntity) => {
		api.getWithParam('training/gettrainingusersbyrole', { //RITM1075974
			params: { Role: role, IdEntity: idEntity, includeAdmins: true },
		})
			.then((response) => {
				this.setState({
					approvers: response.data,
					isLoadingApproverOptions: false,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.ROLE, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingApproverOptions: false,
				});
			});
	};

	//RITM0984969
	getDataApproverUser = () => {
		api.getWithParam('training/getTrainingDataApproverByEmail', {
			params: {},
		})
			.then((response) => {
				this.setState({
					approvers: response.data,
					isLoadingApproverOptions: false,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.ROLE, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingApproverOptions: false,
				});
			});
	};
	//end
	handleConfirmApprovalModal = () => {
		let action = this.state.approvalModalAction?.toLowerCase();
		let apiEndpoint = this.state.approvalEndpoint;

		const data = {
			ids: [this.state.idTraining],
			owner: this.state.approver,
			workflowNotes: this.state.approvalNotes,
		};

		this.setState({
			isLoadingWFOperation: true,
		});
		api.put("/training/" + apiEndpoint, data, "")
			.then((response) => {
				if (response.status === 200) {
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.TRAINING, apioperation.PUT));
					this.setState({
						isLoadingWFOperation: false,
						isApprovalModalOpen: false,
						isLoading: true,
					});
					this.props.history.push("/training");
				} else {
					showNotification.error();
					this.setState({
						isLoadingWFOperation: false,
					});
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.PUT));
				this.setState({
					isLoadingWFOperation: false,
				});
			})
			.finally(() => { });
	};
	batchActionClick(actionKey, actionName, approverRole, withApprover, approvalNotesRequired, selectedRows) {
		var training = this.state.model;

		var idEntity = actionKey == "Submit" ? training.idWorkSite : actionKey == "Approve" ? training.idDivision : null;

		this.setState({
			approvalModalAction: actionName,
			isApprovalModalOpen: true,
			isLoadingApproverOptions: true,
			withApprover: withApprover,
			selectedData: selectedRows,
			approverRole: approverRole,
			approvalEndpoint: actionKey,
			approvalNotesRequired: approvalNotesRequired,
		});

		if (withApprover && approverRole != "Data Approver") this.getUsersInRole(approverRole, idEntity);//RITM0984969

		if (approverRole == "Data Approver" && !IsInRole(this.context.user, "Administrator")) this.getDataApproverUser(); //RITM0984969
		if (approverRole == "Data Approver" && IsInRole(this.context.user, "Administrator")) this.getUsersInRole(approverRole, idEntity); //RITM0984969
	}

	getStatusActions = (user) => {
		if (!this.IsRowSelectable()) return null;

		const idStatus = this.state.model.idStatus;
		const repType = this.state.model.reportingType != "HSE" ? true : false;//RITM0984969

		return (
			<Online>
				{CanExecuteAction("Training", "Reporting", user, idStatus, "Submit", this.state.model) ? (
					<Button renderIcon={Send16} onClick={() => this.batchActionClick("Submit", "Submit", "Data Approver", true, false, null)}>
						Submit Report
					</Button>
				) : null}
				{/* RITM0565449,RITM0984969 */}
				{CanExecuteAction("Training", "Reporting", user, idStatus, "Approve", this.state.model) ? (
					<Button renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("Approve", "Approve", "null", false, repType, null)}>
						Approve Report
					</Button>
				) : null}
				{/* FINE RITM0565449,RITM0984969 */}

				{CanExecuteAction("Training", "Reporting", user, idStatus, "Consolidate", this.state.model) ? (
					<Button renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("Consolidate", "Consolidate", null, false, false, null)}>
						Consolidate Report
					</Button>
				) : null}

				{CanExecuteAction("Training", "Reporting", user, idStatus, "Reject", this.state.model) ? (
					<Button renderIcon={Error16} onClick={() => this.batchActionClick("Reject", "Reject", null, false, true, null)}>
						Reject Report
					</Button>
				) : null}

				{CanExecuteAction("Training", "Reporting", user, idStatus, "RejectConsolidate", this.state.model) ? (
					<Button renderIcon={Error16} onClick={() => this.batchActionClick("RejectConsolidate", "Reject", null, false, true, null)}>
						Reject Report
					</Button>
				) : null}

				{CanExecuteAction("Training", "Reporting", user, idStatus, "Delete", this.state.model) ? (
					<Button renderIcon={Delete16} onClick={() => this.batchActionClick("Delete", "Delete", null, false, false, null)}>
						Delete
					</Button>
				) : null}
			</Online>
		);
	};
	///fine WF
	showDownloadSingleCert = (item) => {
		//visualizzo il pulsante download certificato sul singolo partecipante

		if (!this.state.isEdit || item.toSave) return false; //training o partecipante non salvato sul db

		if (this.state.model == null || (this.state.model.info == null && this.state.model.lihsInfo == null)) return false;

		return item.knowledgeAssessment == "Pass";

	};
	//RITM0984969

	renderTrainingCourses(trainingCourses) {

		return trainingCourses == null || trainingCourses.length == 0 ? (
			<NoRecordsPlaceholder labelText="No Records" colSpan={6} />
		) : (
			trainingCourses.map((item, index) => (
				<TableRow key={"row_" + item.id}>
					{this.state.model.reportingType == "HSE" && (
						<TableCell key={"cell_title_" + item.id}>{item.info.courseCode}</TableCell>
					)}
					{this.state.model.reportingType != "HSE" && (
						<TableCell key={"cell_title_" + item.id}>{item.lihsInfo.courseCode}</TableCell>
					)}
				
				    <TableCell key={"cell_actualTrainingName_" + item.id}>{item.actualTrainingName}</TableCell>
					<TableCell key={"cell_language_" + item.id}>{item.language}</TableCell>
					<TableCell key={"cell_duration_" + item.id}>{item.certifiedDuration}</TableCell>
					<TableCell key={"cell_cm_" + item.id}>{item.certificateValidityMonths}</TableCell>

					<TableCell key={"action-" + item.id} className="tableActions align-center">
						{!this.state.isDisabled && (
							<div>
								<Button onClick={() => this.editTrainingCourse(item.id)} size="small" renderIcon={Edit16} iconDescription="Edit" title="Edit" kind="ghost" />
								<Button onClick={() => this.confirmDeleteTrainingCourse(item.id)} size="small" renderIcon={Delete16} iconDescription="Delete" title="Delete" kind="ghost" />
							</div>
						)}
					</TableCell>
				</TableRow>
			))
		);
	}
	renderParticipants(isSaipem, participants) {
		let trainingParticipants = isSaipem ? (participants || []).filter((el) => el.type.toLowerCase() == "saipem" || el.type.toLowerCase() == "jv (saipem personnel)" || el.type.toLowerCase() == "jv (non saipem personnel)") : (participants || []).filter((el) => el.type.toLowerCase() != "saipem" && el.type.toLowerCase() != "jv (saipem personnel)" && el.type.toLowerCase() != "jv (non saipem personnel)");

		if (trainingParticipants && trainingParticipants.length) {
			trainingParticipants = _sortBy(trainingParticipants, [(p) => p.type?.toLowerCase(), (p) => p.surname?.toLowerCase(), (p) => p.name?.toLowerCase()]);
		}



		const fileDownLoadButtonProps = {
			size: "small",
			className: "bx--export-form",
			iconDescription: "Download Certificate",
			title: "Download Certificate",
			kind: "ghost",
			onDownLoadStart: () => {
				this.setState({
					isLoadingNotificationFile: true,
				});
			},
			onDownLoadEnd: () => {
				this.setState({
					isLoadingNotificationFile: false,
				});
			},
			onError: (error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGCERTIFICATE, apioperation.DOWNLOAD));
			},
		};

		return trainingParticipants == null || trainingParticipants.length == 0 ? (
			<NoRecordsPlaceholder labelText="No Records" colSpan={11} />
		) : (
			trainingParticipants.map((item, index) => (
				<TableRow key={"row_" + item.id}>
					<TableCell key={"cell_SNo_" + item.id}>{index + 1}</TableCell>
					<TableCell key={"cell_type_" + item.id}>{item.type}</TableCell>
					<TableCell key={"cell_badgeNumber_" + item.id}>{item.badgeNumber}</TableCell>
					<TableCell key={"cell_surname_" + item.id}>{item.surname}</TableCell>
					<TableCell key={"cell_name_" + item.id}>{item.name}</TableCell>
					{this.state.model.reportingType !== null
						&& this.state.model.reportingType == 'HSE' && (<TableCell colSpan={2} key={"cell_position_" + item.id}>{item.position}</TableCell>)}
					{this.state.model.reportingType !== null
						&& this.state.model.reportingType !== 'HSE' && (<TableCell key={"cell_worksite_" + item.id}>{item.workSite}</TableCell>)}
					{this.state.model.reportingType !== null
						&& this.state.model.reportingType !== 'HSE' && (<TableCell key={"cell_project_" + item.id}>{item.project}</TableCell>)}
					<TableCell key={"cell_company_" + item.id}>{item.company}</TableCell>
					<TableCell key={"cell_knowledgeAssessment_" + item.id}>{item.knowledgeAssessment}</TableCell>
					<TableCell key={"sign-" + item.id} className="tableActions align-center">
						{!this.state.isDisabled && (
							<div>
								{this.state.isEdit && item.signatureAttachment && <Checkmark24 fill="#1A3E4C" aria-label="" />}
								{this.state.isEdit && !item.toSave && (
									<Button onClick={() => this.editParticipantsSign(item.id)} size="small" renderIcon={PaintBrushAlt16} iconDescription="Edit Signature" title="Edit Signature" kind="ghost" />
								)}
							</div>
						)}
					</TableCell>
					<TableCell key={"action-" + item.id} className="tableActions align-center">
						{!this.state.isDisabled && (
							<div>
								{this.showDownloadSingleCert(item) && (
									<Online>
										<FileDownLoadButton
											{...fileDownLoadButtonProps}
											renderIcon={CertificateCheck16}
											apiUrl={`/training/${this.state.idTraining}/participant/${item.id}/certificate`}
											fileName={`Training_Certificate_${this.state.model.code}_${item.surname}_${item.name}.pdf`}
										/>
									</Online>
								)}

								<Button onClick={() => this.editParticipant(item.id)} size="small" renderIcon={Edit16} iconDescription="Edit" title="Edit" kind="ghost" />
								<Button onClick={() => this.confirmDeleteParticipant(item.id)} size="small" renderIcon={Delete16} iconDescription="Delete" title="Delete" kind="ghost" />
							</div>
						)}
					</TableCell>
				</TableRow>
			))
		);
	}
	renderTrainers(isInternal, trainers) {

		let trainingTrainers = isInternal ? (trainers || []).filter((el) => el.type.toLowerCase() == "internal") : (trainers || []).filter((el) => el.type.toLowerCase() != "internal");
		if (trainingTrainers && trainingTrainers.length) {
			trainingTrainers = _sortBy(trainingTrainers, [(p) => p.type?.toLowerCase(), (p) => p.surname?.toLowerCase(), (p) => p.name?.toLowerCase()]);
		}

		return trainingTrainers == null || trainingTrainers.length == 0 ? (
			<NoRecordsPlaceholder labelText="No Records" colSpan={5} />
		) : (
			trainingTrainers.map((item, index) => (
				<TableRow key={"row_" + item.id}>
					<TableCell key={"cell_type_" + item.id}>{item.type}</TableCell>
					<TableCell key={"cell_surname_" + item.id}>{item.surname}</TableCell>
					<TableCell key={"cell_name_" + item.id}>{item.name}</TableCell>
					<TableCell key={"cell_lead_" + item.id}>{item.leadTrainer ? "Yes" : ""}</TableCell>

					<TableCell key={"sign-" + item.id} className="tableActions align-center">
						{!this.state.isDisabled && (
							<div>
								{this.state.isEdit && item.signatureAttachment && <Checkmark24 fill="#1A3E4C" aria-label="" />}
								{this.state.isEdit && !item.toSave && (
									<Button onClick={() => this.editTrainersSign(item.id)} size="small" renderIcon={PaintBrushAlt16} iconDescription="Edit Signature" title="Edit Signature" kind="ghost" />
								)}
							</div>
						)}
					</TableCell>
					<TableCell key={"action-" + item.id} className="tableActions align-center">
						{!this.state.isDisabled && (
							<div>
								<Button onClick={() => this.editTrainingTrainer(item.id)} size="small" renderIcon={Edit16} iconDescription="Edit" title="Edit" kind="ghost" />
								<Button onClick={() => this.confirmDeleteTrainingTrainer(item.id)} size="small" renderIcon={Delete16} iconDescription="Delete" title="Delete" kind="ghost" />
							</div>
						)}
					</TableCell>
				</TableRow>
			))
		);
	}

	checkValidHours = (value) => {
		
		const hours = value ? +value : null
		const decimal = hours ? +hours.toString().split(".").splice(1).join() : 0

		if (!hours || (decimal !== 0 && decimal !== 5)) return false
		if (this.state.model.info != null && this.state.model.info.minDuration != null && value < this.state.model.info.minDuration) return false
		if (this.state.model.info != null && this.state.model.info.maxDuration != null && value > this.state.model.info.maxDuration) return false
		if (this.state.model.lihsInfo != null && this.state.model.lihsInfo.minDuration != null && value < this.state.model.lihsInfo.minDuration) return false
		if (this.state.model.lihsInfo != null && this.state.model.lihsInfo.maxDuration != null && value > this.state.model.lihsInfo.maxDuration) return false

		return true
	}
	checkNoOfCourses = () => {
		
		if (!this.state.isEdit) {
			if (this.state.model.trainingCourses.length ==0) return false
			if (this.state.model.reportingStyle == "Multiple" && parseInt(this.state.model.noOfCourses) !== this.state.model.trainingCourses.length) return false
		}
		return true
	}
	
	getTrainingParticipants = () => {
		api.getAll(`training/${this.state.model.id}/participant`)
			.then((response) => {
				this.setState({
					model: { ...this.state.model, trainingParticipant: response.data }
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGPARTICIPANT, apioperation.GET));
			});
	};

	uploadTemplate = (event) => {
		if (this.state.statusUpload != null) {
			this.setState({
				isImportfunction: true,
				isImportTemplate: true,
				message: [],
			});
			event.preventDefault();
			this.setState(() => ({
				canUpload: true,
				isFileValid: true,
				validationErrorTitle: "",
				validationErrorSubTitle: "",
				statusUpload: "uploading",
			}));
			const formData = new FormData();
			formData.append("FileUploaded", event.target.inputFile.files[0]);
			
			
			//RITM0984969
			api.upload(`/training/${this.state.model.id}/${this.state.isEdit}/trainingParticipant/template`, formData)
				.then((response) => {
				
					this.setState(() => ({
						canUpload: false,
						isFileValid: true,
						validationErrorTitle: "",
						validationErrorSubTitle: "",
						statusUpload: "complete",
						message: response.data.listMessages,
						isImportTemplate: false,
						isImportfunction: false,
					}));

					if (response.data && response.data.listMessages[0] == "Success") {
						showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.TRAININGPARTICIPANTTEMPLATE, apioperation.UPLOAD));
						this.setState(() => ({
							isImportTemplateModalOpen: false
						}));

					} else {
						this.setState({
							statusUpload: null
						});
					}
					if (this.state.isEdit == true) {
						this.getTrainingParticipants()
					}
					if (this.state.isEdit == false) {
						let uniqueParticipantList = (this.state.model.trainingParticipant.concat(response.data.listParticipants)).filter(
							(obj, index, self) =>
								index === self.findIndex(
									(t) => t.surname === obj.surname &&
										t.name === obj.name &&
										t.type === obj.type && t.badgeNumber === obj.badgeNumber && t.company === obj.company
								)
						);
						
						
						const saipemTrainerFound = uniqueParticipantList.filter(o => (this.state.model.trainingTrainer.filter((el) => el.type.toLowerCase() == "internal")).some(({ badgeNumber, name, surname }) => o.badgeNumber === badgeNumber && o.name.toLowerCase() === name.toLowerCase() && o.surname.toLowerCase() === surname.toLowerCase()));

						if (saipemTrainerFound.length > 0) {
								uniqueParticipantList = uniqueParticipantList.filter(each => {
								return !saipemTrainerFound.map((l) => l.id).includes(each.id)
							});
						}
						
						const nonSaipemTrainerFound = uniqueParticipantList.filter(o => (this.state.model.trainingTrainer.filter((el) => el.type.toLowerCase() == "external")).some(({ name, surname }) => o.name.toLowerCase() === name.toLowerCase() && o.surname.toLowerCase() === surname.toLowerCase()));
						
						if (nonSaipemTrainerFound.length > 0)
						{
							uniqueParticipantList = uniqueParticipantList.filter(each => {
								return !nonSaipemTrainerFound.map((l) => l.id).includes(each.id)
							});
						}

						
						this.setState({
							
							model: { ...this.state.model, trainingParticipant: uniqueParticipantList }
						});

					}
				})
				.catch((error) => {
					this.setState(() => ({
						canUpload: true,
						isFileValid: false,
						statusUpload: "edit",
						isImportTemplate: false,
						isImportfunction: false,
						importDanger: true,
					}));
					showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGPARTICIPANTTEMPLATE, apioperation.UPLOAD));
				});
		}
	};

	onFileUploadChange = (evt) => {
		this.setState(() => ({ statusUpload: "edit" }));
		if (evt.target.files[0] && evt.target.files[0].size >= 4194304) {
			const nome = evt.target.files[0].name;
			this.fileUploader.clearFiles();
			this.setState(() => ({
				canUpload: false,
				message: [],
				isFileValid: false,
				isImportTemplate: false,
				validationErrorTitle: `${nome} exceeds size limit`,
				validationErrorSubTitle: "4mb max file size. Please select a new file and try again",
			}));
		} else {
			// this.fileUploader.clearFiles();
			this.setState(() => ({
				canUpload: true,
				isFileValid: true,
				validationErrorTitle: "",
				validationErrorSubTitle: "",
				message: [],
			}));
		}
	};

	toggleModalUploadTemplate = (open) => {
		this.fileUploader.clearFiles();
		this.setState({
			isImportTemplateModalOpen: open,
			isImportHC: true,
			message: [],
			statusUpload: null,
			canUpload: false,
			isFileValid: true,
			validationErrorTitle: "",
			validationErrorSubTitle: "",
			__filename: null,
		});
	};

	clearFiles = () => {
		this.fileUploader.clearFiles();
		this.setState(() => ({
			canUpload: false,
			isFileValid: true,
			validationErrorTitle: "",
			validationErrorSubTitle: "",
		}));
	};

	divMessaggImportHC() {
		return (
			<div>
				{!this.state.isImportTemplate ? "" : <Loading />}

				{this.state.message[0] == "Success" ? (
					<div />
				) : (
					<div>
						{this.state.message.map((x) => (
							<div className="bx--row">
								<div className="srv-validation-message"> {x}</div>
							</div>
						))}
					</div>
				)}
			</div>
		);
	}

	renderUploadModal = () => (
		<form onSubmit={this.uploadTemplate}>
			<ComposedModal className="light-modal" open={this.state.isImportTemplateModalOpen} danger="false" onClose={() => false}>
				<ModalHeader className="margin-modal" buttonOnClick={() => this.toggleModalUploadTemplate(false)}>
					<p>Import Training Participants</p>
				</ModalHeader>
				<ModalBody className="margin-modal">
					<div className="bx--file-container">
						<FileUploader
							ref={(node) => (this.fileUploader = node)}
							accept={[".xlsx"]}
							buttonKind="primary"
							buttonLabel="Choose a file"
							filenameStatus={this.state.statusUpload}
							iconDescription="Choose"
							labelTitle="Upload"
							multiple={false}
							name="inputFile"
							onClick={this.clearFiles}
							onChange={this.onFileUploadChange}
						/>
					</div>
					<div>
						{this.state.isImportHC ? this.divMessaggImportHC() : ""}
						{this.state.isImportfunction ? <Loading /> : ""}
					</div>
				</ModalBody>
				<ModalFooter>
					<Button kind="secondary" onClick={() => this.toggleModalUploadTemplate(false)}>
						Cancel
					</Button>
					<Button kind="primary" type={this.state.statusUpload != null ? "submit" : "button"} onClick={this.state.statusUpload != null ? this.clearFiles : null} disabled={!this.state.statusUpload}>
						Upload
					</Button>
				</ModalFooter>
			</ComposedModal>
		</form>
	);

	// RITM0562378
	clearAttachment = () => ({
		id: null, // guid
		fileIdentifier: null,
		name: null,
		contentType: null,
		size: null,
		type: null,
	});

	onUploadFiles = (fileIdentifier, fileName, fileType, size) => {
		const attachment = { ...this.state.attachment };

		attachment.id = uuid();
		attachment.fileIdentifier = fileIdentifier.blobName;
		attachment.name = fileName;
		attachment.contentType = fileType;
		attachment.size = size;
		// attachment.filePath = file.localPath;

		this.setState({
			attachment: this.clearAttachment(),
		});

		try {
			if (attachment == null) return;
			// insert
			const oldattachment = this.state.model.attachments || [];

			const newItem = {
				id: uuid(), // guid

				idAttachment: attachment.id, // guid
				attachment,
			};

			const newattachment = oldattachment.concat([newItem]);
			this.setState({ model: { ...this.state.model, attachments: newattachment } })
		} catch (error) {
			showNotification.error();
		}
	};

	onRemoveFile = (id) => {
		if (!id) return;
		const statusCopy = { ...this.state.model };
		statusCopy.attachments = statusCopy.attachments.filter((el) => el.id !== id);
		this.setState({ model: statusCopy });
	};
	// FINE RITM0562378
	returnTrainingMethodLists = (id) => this.state.model.trainingMethodLists?.find(el => el.idTrainingMethod == id) ? true : false //RITM0984969
	returnTrainingAssessmentMethodLists = (id) => this.state.model.trainingAssessmentMethodLists?.find(el => el.idTrainingAssessmentMethod == id) ? true : false //RITM0984969

	render() {
		const appWorksites = this.getWorkSite(this.state.model.startDate, this.state.model.endDate);
		const appProject = this.getPrj(this.state.model.idWorkSite, this.state.model.startDate, this.state.model.endDate);
		//RITM0984969
		const appTrainingMethodList = (this.state.appTrainingMethodList || []).filter(
			(el) => (el.inUse) || this.state.model?.trainingMethodLists?.find(elem => elem?.idTrainingMethod == el.id));
		const appTrainingAssessmentMethodList = (this.state.appTrainingAssessmentMethodList || []).filter(
			(el) => (el.inUse) || this.state.model?.trainingAssessmentMethodLists?.find(elem => elem?.idTrainingAssessmentMethod == el.id));
		//End
		const selectedItemCombo = {
			idWorkSite: (appWorksites || []).find((el) => el.id == this.state.model.idWorkSite),
			idProject: (appProject || []).find((el) => el.id == this.state.model.idProject),
			idTrainingData: (this.state.appTrainingData || []).find((el) => el.id == this.state.model.idTrainingData) ,//RITM0984969
			idLanguage: (this.state.appLanguage || []).find((el) => el.id == this.state.model.idLanguage),
			idCountry: (this.state.appCountry || []).find((el) => el.id == this.state.model.idCountry),
			idMethod: (this.state.appMethod || []).find((el) => el.id == this.state.model.idMethod),
			idTrainingAssessmentMethod: (this.state.appAssessmentMethod || []).find((el) => el.id == this.state.model.idTrainingAssessmentMethod),
			idTrainingCenter: (this.state.appTrainingCenters || []).find((el) => el.id == this.state.model.idTrainingCenter),
			//RITM0984969
			idLihsTrainingData: (this.state.appLihsTrainingData || []).find((el) => el.id == this.state.model.idLihsTrainingData) ,//RITM0984969
			reportingType: this.state.model
				? (this.state.appReportingType || []).find(
					(el) =>
						el.text == this.state.model.reportingType
				)
				: null,
			reportingStyle: this.state.model
				? (this.state.appReportingStyle || []).find(
					(el) =>
						el.text == this.state.model.reportingStyle
				)
				: null,
			noOfCourses: this.state.model
				? (this.state.appNoOfCourses || []).find(
					(el) =>
						el.text == this.state.model.noOfCourses
				)
				: null,

			selectedTrainingMethodLists: (appTrainingMethodList || []).filter(
				(el) => this.returnTrainingMethodLists(el.id)),
			selectedTrainingAssessmentMethodLists: (appTrainingAssessmentMethodList || []).filter(
				(el) => this.returnTrainingAssessmentMethodLists(el.id)),
			//end

		};



		const showOtherAssessment = selectedItemCombo.idTrainingAssessmentMethod?.specifyOther;
		//RITM0984969
		const showReportingStyle = !this.state.isEdit ? selectedItemCombo.reportingType != null && selectedItemCombo.reportingType.text === "HSE" : false;
		const showNoOfcourses = !this.state.isEdit ? selectedItemCombo.reportingStyle != null && selectedItemCombo.reportingStyle.text === "Multiple" : false;
		const showOtherTrainingAssessmentMethod = this.state.isEdit ? selectedItemCombo.selectedTrainingAssessmentMethodLists.find(el => el.name.toLowerCase() === 'other (specify)')?.specifyOther : false; //RITM0984969
		const showActualTrainingName = (this.state.model.reportingType == "HSE") ? this.state.model.info != null && this.state.model.info.actualTrainingName == true
			: false;
		const showLihsActualTrainingName = (this.state.model.reportingType != "HSE") ? this.state.model.lihsinfo != null && this.state.model.lihsinfo.actualTrainingName == true : false;

		//end

		this.validator.purgeFields(); //si usa quando ci sono validazioni condizionali tra più campi
		const validations = {
			startDate: this.validator.message("StartDate", this.state.model.startDate, "required"),
			endDate: this.validator.message("EndDate", this.state.model.endDate, "required"),
			endAfterStart: this.validator.message(
				"endAfterStart",
				this.state.model.endDate == null || this.state.model.startDate == null || moment(this.state.model.endDate).isSameOrAfter(moment(this.state.model.startDate), "day"),
				"accepted"
			),
			
			validityDate: this.state.isEdit ? this.validator.message("ValidityDate", this.state.model.validityDate, "required") : null,
			certificateValidityMonths: this.state.isEdit
				? this.validator.message("CertificateValidityPeriod", this.state.model.certificateValidityMonths, "required|gtz") : null,
		
			idTrainingData: this.state.isEdit ? (this.state.model.reportingType == "HSE") ? this.validator.message("TrainingData", this.state.model.idTrainingData, "required") : this.validator.message("TrainingData", this.state.model.idLihsTrainingData, "required") : null,
			//trainer: this.validator.message("trainer", this.state.model.trainer, "required"),
			idWorkSite: this.validator.message("WorkSite", this.state.model.idWorkSite, "required"),
			idProject: this.validator.message("Project", this.state.model.idProject, "required"),
			//idLanguage: this.validator.message("Language", this.state.model.idLanguage, "required"),
			//idMethod: this.validator.message("Method", this.state.model.idMethod, "required"),
			//idTrainingAssessmentMethod: this.validator.message("AssessmentMethod", this.state.model.idTrainingAssessmentMethod, "required"),
			specifyOtherAssessmentMethod: showOtherAssessment ? this.validator.message("SpecifyOtherAssessmentMethod", this.state.model.specifyOtherAssessmentMethod, "required") : null,
			certifiedDuration: this.state.isEdit ? this.validator.message("Certified Duration", this.state.model.certifiedDuration, "required") : null,

			//RITM0984969
			idTrainingCenter: this.validator.message("Training Center", this.state.model.idTrainingCenter, "required"),
			reportingType: !this.state.isEdit
				? this.validator.message('Type Of Reporting', this.state.model.reportingType, 'required')
				: null,
			reportingStyle: showReportingStyle
				? this.validator.message(
					'reporting style',
					this.state.model.reportingStyle,
					'required'
				)
				: null,
			noOfCourses: showNoOfcourses
				? this.validator.message(
					'no Of courses',
					this.state.model.noOfCourses,
					'required'
				)
				: null,
			trainingMethodList: this.state.isEdit ? this.validator.message("Training Method", (this.state.model?.trainingMethodLists || [])[0], "required") : null,
			trainingAssessmentMethodList: this.state.isEdit ? this.validator.message("Training Assessment Method", (this.state.model?.trainingAssessmentMethodLists || [])[0], "required") : null,
			TrainingAssessmentMethodSpecifyOther: this.state.isEdit ? this.validator.message("Training Assessment Method Specify Other", showOtherTrainingAssessmentMethod == true && (this.state.model?.trainingAssessmentMethodLists || []).find(el => el?.trainingAssessmentMethod?.name?.toLowerCase() == 'other (specify)')?.specifyOther, "required") : null,
			trainerList: this.validator.message("Trainer", (this.state.model.trainingTrainer || [])[0], "required"),
		//	attachmentList: this.state.isEdit ? this.validator.message("Attachment", (this.state.model.attachments || [])[0], "required") : null,
			contentList: (this.state.info?.actualTrainingName || this.state.lihsInfo?.actualTrainingName) && this.state.isEdit  ? this.validator.message("Course Contents", (this.state.model.trainingContents || [])[0], "required") : null,
			actualTrainingName: this.validator.message("Actual Training Name", (showActualTrainingName == true || showLihsActualTrainingName == true) && (this.state.model.actualTrainingName), "required"),
		};

		const trainingContents = this.state.model.trainingContents ? _sortBy(this.state.model.trainingContents, "createdOn") : [];
		const trainingParticipants = this.state.search
			? (this.state.model.trainingParticipant || []).filter((el) => `${el.surname} ${el.name}`?.toLowerCase().includes(this.state.search?.toLowerCase()))
			: this.state.model.trainingParticipant || [];

		//RITM0984969
		const trainingTrainers = this.state.model.trainingTrainer ? _sortBy(this.state.model.trainingTrainer, "createdOn") : [];
		const trainingCourses = this.state.model.trainingCourses ? this.state.model.trainingCourses : [];

		//RITM0984969
		const modalTrainingCourseProps = {
			trainingCourses: this.state.model.trainingCourses,
			key: this.state.keyModalTrainingCourse,
			title: "Course Details",
			editModel: this.state.idToEditTrainingCourse ? trainingCourses.find((el) => el.id == this.state.idToEditTrainingCourse) : null,
			isOpenModal: this.state.isOpenModalTrainingCourse,
			isEditModal: this.state.idToEditTrainingCourse != null,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalTrainingCourse"),
			save: this.handleSaveModalTrainingCourse,
			titleAlert: String.fromCharCode(9888) + " Do Not use Personal Accounts",
			startDate: this.state.model.startDate,
			endDate: this.state.model.endDate,
			appTrainingData: this.state.appTrainingData,
			appLanguage: this.state.appLanguage,
			appTrainingMethodList: this.state.appTrainingMethodList,
			appTrainingAssessmentMethodList: this.state.appTrainingAssessmentMethodList,
			appLihsTrainingData: this.state.appLihsTrainingData,
			reportingType: this.state.model.reportingType,

		};

		const modalContentProps = {
			key: this.state.keyModalContent,
			//title: "Course Contents  (The mention of names and surnames must be done only if strictly necessary. Personal Email Addresses are not allowed)", //RITM0984969
			title: "Course Contents / Remarks  (The mention of names and surnames must be done only if strictly necessary. Personal Email Addresses are not allowed)", //RITM0984969
			editModel: this.state.idToEditContent ? trainingContents.find((el) => el.id == this.state.idToEditContent) : null,
			isOpenModal: this.state.isOpenModalContent,
			isEditModal: this.state.idToEditContent != null,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalContent"),
			save: this.handleSaveModalContent,
			titleAlert: String.fromCharCode(9888) + " Do Not use Personal Accounts",

		};

		const modalParticipantProps = {
			participants: this.state.model.trainingParticipant,
			key: this.state.keyModalParticipant,
			title: "Course Participants",
			editModel: this.state.idToEditParticipant ? trainingParticipants.find((el) => el.id == this.state.idToEditParticipant) : null,
			isOpenModal: this.state.isOpenModalParticipant,
			isEditModal: this.state.idToEditParticipant != null,
			mode: this.state.idToEditParticipant != null ? 2 : 0,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalParticipant"),
			save: this.handleSaveModalParticipant,
			appType: this.state.appInfoOriginator,
			//RITM0984969 start
			startDate: this.state.model.startDate,
			endDate: this.state.model.endDate,
			division: this.state.model.idDivision,
			appAllWorksites: this.state.appAllWorksites,
			appAllProjects: this.state.appAllWorksitePrj,
			reportingType: this.state.model.reportingType,
			trainingTrainer:this.state.model.trainingTrainer,
			//RITM0984969 end
		};

		const modalTrainerProps = {
			key: this.state.keyModalTrainer,
			title: "Trainer",
			editModel: this.state.model.trainer,
			isOpenModal: this.state.isOpenModalTrainer,
			isEditModal: this.state.model.trainer != null,
			mode: 2,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalTrainer"),
			save: this.handleSaveModalTrainer,
			//RITM0984969 start
			reportingStyle: this.state.model.reportingStyle,
			reportingType: this.state.model.reportingType,
			//RITM0984969 end
		};

		const modalTrainingTrainerProps = { //RITM0984969
			trainers: this.state.model.trainingTrainer,
			key: this.state.keyModalTrainingTrainer,
			title: "Trainers",
			editModel: this.state.idToEditTrainingTrainer ? trainingTrainers.find((el) => el.id == this.state.idToEditTrainingTrainer) : null,
			isOpenModal: this.state.isOpenModalTrainingTrainer,
			isEditModal: this.state.idToEditTrainingTrainer != null,
			mode: this.state.idToEditTrainingTrainer != null ? 2 : 0,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalTrainingTrainer"),
			save: this.handleSaveModalTrainingTrainer,
			appType: this.state.appInfoOriginator,
			trainingParticipant: this.state.model.trainingParticipant,
		};

		const modalSignatureProps = {
			key: this.state.keyModalTrainerSign,
			title: "Trainer Signature",
			editModel: this.state.model.trainer,
			isOpenModal: this.state.isOpenModalTrainerSign,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalTrainerSign"),
			save: this.handleSaveModalTrainerSign,
			idTraining: this.state.idTraining,
		};

		const modalTrainersSignatureProps = { //RITM0984969
			key: this.state.keyModalTrainersSign,
			title: "Trainer Signature",
			editModel: this.state.idToEditTrainersSign ? trainingTrainers.find((el) => el.id == this.state.idToEditTrainersSign) : null,
			isOpenModal: this.state.isOpenModalTrainersSign,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalTrainersSign"),
			save: this.handleSaveModalTrainersSign,
			idTraining: this.state.idTraining,
		};

		const modalParticipantsSignatureProps = {
			key: this.state.keyModalParticipantsSign,
			title: "Participant Signature",
			editModel: this.state.idToEditParticipantsSign ? trainingParticipants.find((el) => el.id == this.state.idToEditParticipantsSign) : null,
			isOpenModal: this.state.isOpenModalParticipantsSign,
			toggleModal: (open) => this.toggleModal(open, "isOpenModalParticipantsSign"),
			save: this.handleSaveModalParticipantsSign,
			idTraining: this.state.idTraining,
		};

		const fileDownLoadAllProps = {
			apiUrl: `/training/${this.state.idTraining}/certificate`,
			fileName: `Training_Certificates_${this.state.model.code}.zip`,
			onDownLoadStart: () => {
				//RITM0962638 - Download All Certificates Fix
				// if(this.state.model.trainer.signatureAttachment == null){
				// 	throw new Error('Trainer Signature is missing')
				// }
				//End
				this.setState({
					isLoadingNotificationFile: true,
				});
			},
			onDownLoadEnd: () => {
				this.setState({
					isLoadingNotificationFile: false,
				});
			},
			onError: (error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGCERTIFICATE, apioperation.DOWNLOAD));
			},
		};

		const confirmDelProps = () => {
			if (this.state.idToDeleteParticipant) {
				return {
					idToDelete: this.state.idToDeleteParticipant,
					nameItem: "",
					isDeleting: this.state.isDeleting,
					open: this.state.isOpenDeleteModal, //open state
					onCloseConfirm: () => this.toggleModal(false, "isOpenDeleteModal"), //no click
					deleteItem: this.deleteItemParticipant, //yes click fn()
				};
			}
			if (this.state.idToDeleteTrainingTrainer) { //RITM0984969
				return {
					idToDelete: this.state.idToDeleteTrainingTrainer,
					nameItem: "",
					isDeleting: this.state.isDeleting,
					open: this.state.isOpenDeleteModal, //open state
					onCloseConfirm: () => this.toggleModal(false, "isOpenDeleteModal"), //no click
					deleteItem: this.deleteItemTrainingTrainer, //yes click fn()
				};
			}
			if (this.state.idToDeleteTrainingCourse) { //RITM0984969
				return {
					idToDelete: this.state.idToDeleteTrainingCourse,
					nameItem: "",
					isDeleting: this.state.isDeleting,
					open: this.state.isOpenDeleteModal,
					onCloseConfirm: () => this.toggleModal(false, "isOpenDeleteModal"),
					deleteItem: this.deleteItemTrainingCourse,
				};
			}
			return {
				idToDelete: this.state.idToDeleteContent,
				nameItem: "",
				isDeleting: this.state.isDeleting,
				open: this.state.isOpenDeleteModal, //open state
				onCloseConfirm: () => this.toggleModal(false, "isOpenDeleteModal"), //no click
				deleteItem: this.deleteItemContent, //yes click fn()
			};
		};

		const showModalSignature = this.state.isEdit && this.state.model.trainer != null;

		return (
			<AppContext.Consumer>
				{({ user }) => (
					<>
						<PageBreadCrumb
							linkTo={!this.state.isEdit ? "/training" : "/training?isBack"}
							linkText="Trainings"
							titleLeft={this.state.isEdit ? "Edit Training" : "New Training" }
							titleCenter={this.state.model.code && "ID: " + this.state.model.code}
							titleRight={this.state.model.status}
							batchActions={this.state.isEdit ? this.getStatusActions(user) : null}
							showButtonHistory={this.state.isEdit ? this.showButtonHistory() : null}
						/>
						<div className="mainContainer">
							<Loading active={this.state.isLoadingNotificationFile} withOverlay />
							<div className="bx--grid content full-width">
								<ConfirmAlertCustom {...confirmDelProps()} />
								{this.renderUploadModal()}
								{this.showLoading()}
								<WFActionModal
									show={this.state.isApprovalModalOpen}
									title={`${this.state.approvalModalAction} Training`}
									action={this.state.approvalModalAction}
									withApprover={this.state.withApprover}
									approver={this.state.approver}
									approverRole={this.state.approverRole}
									approverOptions={this.state.approvers}
									isLoadingOperation={this.state.isLoadingWFOperation}
									onApproverSelect={this.handleApproverSelect}
									isLoadingOptions={this.state.isLoadingApproverOptions}
									onCancel={this.handleCloseApprovalModal}
									onConfirm={this.handleConfirmApprovalModal}
									onApprovalNotesChange={this.handleApprovalNotesChange}
									approvalNotes={this.state.approvalNotes}
									approvalNotesRequired={this.state.approvalNotesRequired}
									validationMessages={this.state.approvalValidationMessages}
								/>

								{this.state.isEdit && <HistoryTable entityId={this.state.idTraining} isOpenModal={this.state.isHistoryModalOpen} onClose={() => this.closeModalHistory()} />}
								<form
									autoComplete="off"
									onSubmit={(e) => {
										e.preventDefault();
									}}
								>
									<div className=" bx--row">
										<div className="bx--col-lg-12 bx--tab-container bx--tab--conteiner-training">
											<ScrollingProvider key="scroll_0">
												<div className="bx--row">
													<div className="padding-progress-indicator-vertical hidden-box">
														<Menu>
															<Item section="sec1">Training Details</Item>{/*RITM0984969*/}
															<Item section="sec5">Trainer Details</Item>{/*RITM0984969*/}
															{/*<Item section="sec2">Course Contents</Item>*/} {/*RITM0984969*/}
															{this.state.isEdit && (<Item section="sec2">Course Contents/ Remarks</Item>)}
															<Item section="sec3">Training Participant</Item>

															{/* RITM0562378 */}
															{this.state.isEdit && (
																<Item section="sec4">Attachment</Item>
															)}
															{/* FINE RITM0562378 */}

														</Menu>
													</div>
													<div className="bx--col-lg-10 bx--col-md-10 margin-progress-indicator-vertical">
														<div className="bx--row">
															<div className="bx--col-lg-6 bx--col-md-4">
																<FormGroup legendText="Type of Reporting*">

																</FormGroup>
															</div>
															<div className="bx--col-lg-6 bx--col-md-4 ">
																<FormGroup legendText="">
																	<ComboBox
																		id="reportingType"
																		key={`reportingType${selectedItemCombo.reportingType}`}
																		placeholder="Select"
																		name="reportingType"
																		alt="model"
																		onChange={(id, val) =>
																			this.updateState(id, (val ? val.text : null), 'model')}
																		itemToString={item => (item ? item.text : '')}
																		initialSelectedItem={selectedItemCombo.reportingType}
																		items={this.state.appReportingType}
																		invalid={validations.reportingType != null}
																		disabled={
																			this.state.isEdit || this.state.model.trainingCourses.length>0
																		}
																	/>
																	{validations.reportingType}
																</FormGroup>
															</div>
															{showReportingStyle && (
																<div className="bx--row ">
																	<div className="bx--col-lg-6 bx--col-md-4">
																		<FormGroup legendText="Reporting Style*">
																			<ComboBox
																				id="reportingStyle"
																				key={`reportingStyle${selectedItemCombo.reportingStyle}`}
																				placeholder="Select"
																				name="reportingStyle"
																				alt="model"
																				onChange={(id, val) =>
																					this.updateState(id, (val ? val.text : null), 'model')}
																				itemToString={item => (item ? item.text : '')}
																				initialSelectedItem={selectedItemCombo.reportingStyle}
																				items={this.state.appReportingStyle}
																				invalid={validations.reportingStyle != null}
																				disabled={
																					this.state.isEdit
																				}
																			/>
																			{validations.reportingStyle}
																		</FormGroup>
																	</div>
																	<div className="bx--col-lg-6 bx--col-md-4">
																		{showNoOfcourses && (
																			<FormGroup legendText="No of Courses conducted*">
																				<ComboBox
																					id="noOfCourses"
																					key={`noOfCourses${selectedItemCombo.noCourses}`}
																					placeholder="Select"
																					name="noOfCourses"
																					alt="model"
																					onChange={(id, val) =>
																						this.updateState(id, (val ? val.text : null), 'model')}
																					itemToString={item => (item ? item.text : '')}
																					initialSelectedItem={selectedItemCombo.noOfCourses}
																					items={this.state.appNoOfCourses}
																					invalid={validations.noOfCourses != null}
																					disabled={
																						this.state.isEdit
																					}
																				/>

																				{validations.noOfCourses}
																			</FormGroup>
																		)}
																	</div>
																</div>
															)}
														</div>
														<Section id="sec1" className="section--title">
															<div className="title-pagination-description">
																<h3 className="title--medium">Training Details</h3>
															</div>

															<div className="bx--row">
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup key="startDate" legendText="Start Date*">
																		<DateTimePicker
																			value={this.state.model.startDate}
																			type="date"
																			disableFutureDate //RITM1126885
																			placeholder={DateFormat}
																			name="startDate"
																			alt="model"
																			invalid={validations.startDate != null}
																			onChange={this.handleChangeDate}
																			disabled={this.state.isDisabled}
																		/>
																		{validations.startDate}
																	</FormGroup>
																</div>
																<div className="bx--col-lg-6 bx--col-md-4 ">
																	<FormGroup key="endDate" legendText="End Date*">
																		<DateTimePicker
																			value={this.state.model.endDate}
																			type="date"
																			placeholder={DateFormat}
																			name="endDate"
																			alt="model"
																			invalid={validations.endDate != null}
																			onChange={this.handleChangeDate}
																			disabled={this.state.isDisabled}
																			
																		/>
																		{validations.endDate}
																		{validations.endAfterStart && <div className="srv-validation-message">The end date field must be after start date field</div>}
																		{/*{validations.endAfterEndDateCutoff && <div className="srv-validation-message">The end date field must be before training end cutoff date field</div>}*/}
																	</FormGroup>
																</div>
															</div>
															<div className="bx--row">
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="Worksite*">
																		<ComboBox
																			id="idWorkSite"
																			key={`idWorkSite${selectedItemCombo.idWorkSite}`}
																			placeholder="Select"
																			name="idWorkSite"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.name : "")}
																			shouldFilterItem={({ item, inputValue }) =>
																				item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
																				item.code.toLowerCase().includes(inputValue.toLowerCase())
																			}
																			initialSelectedItem={selectedItemCombo.idWorkSite}
																			items={appWorksites}
																			disabled={appWorksites == null || this.state.isDisabled || appWorksites.length == 0}
																			invalid={validations.idWorkSite != null}
																		/>
																		{validations.idWorkSite}
																	</FormGroup>
																</div>
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="Project*">
																		<ComboBox
																			id="idProject"
																			key={`idProject${selectedItemCombo.idProject}`}
																			placeholder="Select"
																			name="idProject"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.name : "")}
																			initialSelectedItem={selectedItemCombo.idProject}
																			items={appProject}
																			disabled={appProject == null || this.state.isDisabled || appProject.length == 0}
																			invalid={validations.idProject != null}
																		/>
																		{validations.idProject}
																	</FormGroup>
																</div>
															</div>

															<div className="bx--row">
																<div className="bx--col-lg-6 bx--col-md-4">
																	{this.state.isEdit && this.state.model.reportingType == "HSE" && (
																		<FormGroup legendText="Training Title And Code*">
																			<ComboBox
																				id="idTrainingData"
																				key={`idTrainingData${this.state.model.idTrainingData}`}
																				placeholder="Select"
																				name="idTrainingData"
																				alt="model"
																				onChange={this.handleChangeCombo}
																				itemToString={(item) => (item ? item.courseCode : "")}
																			    initialSelectedItem={selectedItemCombo.idTrainingData}
																				//selectedItem={selectedItemCombo.idTrainingData}
																				items={this.returnValidTrainingData(this.state.appTrainingData) ?? []}
																				disabled={this.state.appTrainingData == null || this.state.isDisabled || !this.state.model.startDate}
																				invalid={validations.idTrainingData != null}
																			/>
																			{validations.idTrainingData}
																		</FormGroup>
																)}
																	{this.state.isEdit && this.state.model.reportingType != "HSE" && (
																		<FormGroup legendText="Training Title And Code*">
																			<ComboBox
																				id="idLihsTrainingData"
																				key={`idLihsTrainingData${this.state.model.idLihsTrainingData}`}
																				placeholder="Select"
																				name="idLihsTrainingData"
																				alt="model"
																				onChange={this.handleChangeCombo}
																				itemToString={(item) => (item ? item.courseCode : "")}
																				initialSelectedItem={selectedItemCombo.idLihsTrainingData}
																				//selectedItem={selectedItemCombo.idLihsTrainingData}
																				items={this.returnValidLihsTrainingData(this.state.appLihsTrainingData) ?? []}
																				disabled={this.state.appLihsTrainingData == null || this.state.isDisabled || !this.state.model.startDate}
																				invalid={validations.idLihsTrainingData != null}
																			/>
																			{validations.idLihsTrainingData}
																		</FormGroup>
																	)}
																</div>
																
																<div className="bx--col-lg-6 bx--col-md-4">
																	{this.state.isEdit && (
																		<FormGroup legendText="Training Delivery Language">
																			<ComboBox
																				id="idLanguage"
																				key={`idLanguage${this.state.model.idLanguage}`}
																				placeholder="Select"
																				name="idLanguage"
																				alt="model"
																				onChange={this.handleChangeCombo}
																				itemToString={(item) => (item ? item.name : "")}
																				initialSelectedItem={selectedItemCombo.idLanguage}
																				items={this.state.appLanguage}
																				disabled={this.state.appLanguage == null || this.state.isDisabled}

																			/>

																		</FormGroup>
																	)}
																</div>
															</div>
															<div className="bx--row">
																<div className="bx--col-lg-6 bx--col-md-4">
																	{this.state.isEdit && this.state.model.reportingType == "HSE" && this.state.model.info?.actualTrainingName && (
																		<FormGroup legendText="Actual Training Name*">

																			<TextInput
																				id="actualTrainingName"
																				name="actualTrainingName"
																				type="text"
																				hideLabel={true}
																				labelText=""
																				onChange={this.handleChangeModel}
																				alt="model"
																				value={(this.state.model && this.state.model.actualTrainingName) || ""}
																			/>
																		{validations.actualTrainingName}
																		</FormGroup>
																	)}
																	{this.state.isEdit && this.state.model.reportingType != "HSE" && this.state.model.lihsInfo?.actualTrainingName &&(
																		<FormGroup legendText="Actual Training Name*">

																			<TextInput
																				id="actualTrainingName"
																				name="actualTrainingName"
																				type="text"
																				hideLabel={true}
																				labelText=""
																				onChange={this.handleChangeModel}
																				alt="model"
																				value={(this.state.model && this.state.model.actualTrainingName) || ""}
																			/>
																			{/*{validations.actualTrainingName}*/}
																		</FormGroup>
																	)}
																</div>

																<div className="bx--col-lg-6 bx--col-md-4">
																	
																</div>
															</div>
															
															<div className="bx--row">
																<div className="bx--col-lg-3 bx--col-md-4">
																	{this.state.isEdit && (
																		<FormGroup legendText="Min Duration (hours)">
																			<TextInput
																				id="Duration"
																				value={(this.state.model.info && this.state.model.info.minDuration) || (this.state.model.lihsInfo && this.state.model.lihsInfo.minDuration)}
																				type="text"
																				hideLabel={true}
																				labelText=""
																				disabled={true}
																				className="bx--text-input disable-text"
																			/>
																		</FormGroup>
																	)}
																</div>
																<div className="bx--col-lg-3 bx--col-md-4">
																	
																	{this.state.isEdit && (
																		<FormGroup legendText="Max Duration (hours)">
																			<TextInput
																				id="Duration"
																				value={(this.state.model.info && this.state.model.info.maxDuration) || (this.state.model.lihsInfo && this.state.model.lihsInfo.maxDuration)}
																				type="text"
																				hideLabel={true}
																				labelText=""
																				disabled={true}
																				className="bx--text-input disable-text"
																			/>
																		</FormGroup>
																	)}
																</div>
																
																<div className="bx--col-lg-3 bx--col-md-4">
																	{this.state.isEdit && (
																		<FormGroup legendText="Duration (hours)*">
																			<TextInput
																				id="certifiedDuration"
																				name="certifiedDuration"
																				value={(this.state.model && this.state.model.certifiedDuration) || ""}
																				labelText=""
																				disabled={ this.state.isDisabled}
																				alt="model"
																				onChange={this.handleChangeModel}
																				type="number"
																				hideLabel={true}
																				invalid={validations.certifiedDuration != null || this.state.invalidCertifiedDuration}
																			/>
																		</FormGroup>
																	)}
																</div>
																<div className="bx--col-lg-3 bx--col-md-4">
																	{this.state.isEdit && (
																		<FormGroup legendText="MyP Code">
																			<TextInput
																				id="PeopleLearningCode"
																				value={(this.state.model.info && this.state.model.info.peopleLearnigCode) || (this.state.model.lihsInfo && this.state.model.lihsInfo.peopleLearnigCode)}
																				type="text"
																				hideLabel={true}
																				labelText=""
																				disabled={true}
																				className="bx--text-input disable-text"
																			/>
																		</FormGroup>
																	)}
																</div>
															</div>
															<div className="bx--row">
																<div className="bx--col-lg-6 bx--col-md-4">
																	<FormGroup legendText="Country">
																		<ComboBox
																			id="idCountry"
																			key={`idCountry${this.state.model.idCountry}`}
																			placeholder="Select"
																			name="idCountry"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.name : "")}
																			initialSelectedItem={selectedItemCombo.idCountry}
																			items={this.state.appCountry}
																		//	disabled={this.state.appCountry == null || this.state.isDisabled}//RITM0984969
																			disabled={true} //RITM0984969
																		/>
																	</FormGroup>
																</div>
																<div className="bx--col-lg-6 bx--col-md-4">
																	{/* RITM0984969 */}
																	{/*		<FormGroup legendText="Training Centre (If Applicable)">*/}
																	<FormGroup legendText="Training Centre*">
																		<ComboBox
																			id="idTrainingCenter"
																			key={`idTrainingCenter${this.state.model.idTrainingCenter}`}
																			placeholder="Select"
																			name="idTrainingCenter"
																			alt="model"
																			onChange={this.handleChangeCombo}
																			itemToString={(item) => (item ? item.name : "")}
																			initialSelectedItem={selectedItemCombo.idTrainingCenter}
																			items={this.state.appTrainingCenters}
																			disabled={this.state.appTrainingCenters == null || this.state.isDisabled}
																		/>
																		{/* RITM0984969 */}
																		{validations.idTrainingCenter}
																	</FormGroup>

																</div>
															</div>
															<div className="bx--row">
																<div className="bx--col-lg-6 bx--col-md-4">
																	{this.state.isEdit && (
																		<FormGroup key="validityDate" legendText="Certificate Validity Period (Years) *">
																			<TextInput
																				className="cell--item"
																				name="certificateValidityMonths"
																				alt="model"
																				value={this.state.model.certificateValidityMonths}
																				onChange={this.handleChangeCertificateValidityPeriod}
																				type="number"
																				min="1"
																				max="10"
																				invalid={validations.certificateValidityMonths != null}
																			/>
																			{validations.certificateValidityMonths}
																		</FormGroup>
																	)}
																</div>

																<div className="bx--col-lg-6 bx--col-md-4">
																	{this.state.isEdit && (
																		<FormGroup key="validityDate" legendText="Certificate Validity Date">
																			<DatePicker
																				datePickerType="simple"
																				value={moment(this.state.model.validityDate).format("DD/MM/YYYY")}
																				className="disable-text"
																			>
																				<DatePickerInput
																					id="certificate-validity-date-input"
																					placeholder=""
																					disabled
																				/>
																			</DatePicker>
																		</FormGroup>
																	)}
																</div>
																
															</div>
															{/* RITM0984969 */}
															<div className="bx--row ">
																<div className="bx--col-lg-6">
																	{this.state.isEdit && (
																		<FormGroup legendText="Training Delivery Methods*">
																			{this.state.isLoadingTraining ? (
																				<DropdownSkeleton />
																			) : (
																				// aggiunto
																				<MultiSelect.Filterable
																					id="guidTrainingMethodList"
																					invalid={validations.trainingMethodList != null}
																					invalidText={validations.trainingMethodList}
																					placeholder={
																						this.state.model.trainingMethodLists?.length < 1 || this.state.model.trainingMethodLists == null
																							? "Choose one or more items"
																							: selectedItemCombo.selectedTrainingMethodLists?.map((elem) => elem.name).join(', ')
																					}
																					itemToString={(item) => (item ? item.name : "")}
																					items={appTrainingMethodList}
																					onChange={this.onChangeTM}
																					type="default"
																					initialSelectedItems={selectedItemCombo.selectedTrainingMethodLists}
																					disabled={this.state.isDisabled}
																					sortItems={(items) => items}
																				/>
																			)}
																		</FormGroup>
																	)}
																</div>
																<div className="bx--col-lg-6">
																	{this.state.isEdit && (
																		<FormGroup legendText="Training Assessment Methods*">
																			{this.state.isLoadingTraining ? (
																				<DropdownSkeleton />
																			) : (
																				<MultiSelect.Filterable
																					id="guidTrainingAssessmentMethodList"
																					invalid={validations.trainingAssessmentMethodList != null}
																					invalidText={validations.trainingAssessmentMethodList}
																					placeholder={
																						this.state.model.trainingAssessmentMethodLists?.length < 1 || this.state.model.trainingAssessmentMethodLists == null
																							? "Choose one or more items"
																							: selectedItemCombo.selectedTrainingAssessmentMethodLists?.map((elem) => elem.name).join(', ')
																					}
																					itemToString={(item) => (item ? item.name : "")}
																					items={appTrainingAssessmentMethodList}
																					onChange={this.onChangeTAM}
																					type="default"
																					initialSelectedItems={selectedItemCombo.selectedTrainingAssessmentMethodLists}
																					disabled={this.state.isDisabled}
																					sortItems={(items) => items}
																				/>
																			)}
																		</FormGroup>
																	)}
																</div>
															</div>
															<div className="bx--row ">
																{showOtherTrainingAssessmentMethod && (
																	<div className="bx--col-lg-6">
																		<FormGroup legendText="Specify other*">
																			<TextInput
																				id="specifyOtherTrainingAssessmentMethod"
																				name="specifyOtherTrainingAssessmentMethod"
																				alt="model"
																				placeholder="Specify other..."
																				value={this.state.model && this.state.model.trainingAssessmentMethodLists?.find(el => el?.trainingAssessmentMethod?.name?.toLowerCase() === 'other (specify)')?.specifyOther || ''}
																				onChange={this.handleSpecifyOtherTrainingAssessmentMethod}
																				type="text"
																				hideLabel={true}
																				labelText=""
																				disabled={this.state.isDisabled}
																				//invalid={validations.TrainingAssessmentMethodSpecifyOther != null}
																			/>
																			{validations.TrainingAssessmentMethodSpecifyOther}
																		</FormGroup>
																	</div>

																)}
															</div>
															{/* End */}
															{/*RITM0984969*/}
															<div className="bx--row">
																<div className="bx--col-lg-12 bx--col-md-12">
																	<FormGroup legendText="">
																		<StructuredListWrapper className="description-table">
																			<StructuredListHead>
																				<StructuredListRow head>

																					<StructuredListCell head>Business Line</StructuredListCell>
																					<StructuredListCell head>Worksite Group</StructuredListCell>
																					<StructuredListCell head>Operating Company</StructuredListCell>

																				</StructuredListRow>
																			</StructuredListHead>
																			<StructuredListBody>
																				<StructuredListRow>
																					<StructuredListCell>
																						{this.state.model.division}
																					</StructuredListCell>
																					<StructuredListCell>
																						{this.state.model.workSiteGroup}
																					</StructuredListCell>
																					<StructuredListCell>
																						{this.state.model.company}
																					</StructuredListCell>

																				</StructuredListRow>
																			</StructuredListBody>
																		</StructuredListWrapper>
																	</FormGroup>
																</div>
															</div>

															{/*RITM0984969*/}
															{/* <div className="bx--row section--title">
                                                            <div>
                                                                <h3 className="title--medium--expressive">Trainer</h3>
                                                            </div>
                                                        </div> */}
															{/*<div className="bx--row row-content">*/}
															{/*	<div className="bx--col-lg-12 bx--col-md-12">*/}
															{/*		<TableToolbar>*/}
															{/*			<h3 className="title--medium max-width"></h3>*/}
															{/*			{!this.state.isDisabled && (*/}
															{/*				<Button*/}
															{/*					onClick={() => {*/}
															{/*						this.editTrainer();*/}
															{/*					}}*/}
															{/*					renderIcon={Edit16}*/}
															{/*				>*/}
															{/*					Edit Trainer*/}
															{/*				</Button>*/}
															{/*			)}*/}
															{/*		</TableToolbar>*/}
															{/*		<FormGroup legendText="">*/}
															{/*			<StructuredListWrapper className="description-table">*/}
															{/*				<StructuredListHead>*/}
															{/*					<StructuredListRow head>*/}
															{/*						<StructuredListCell head>Trainer Type</StructuredListCell>*/}
															{/*						<StructuredListCell head>Trainer Surname</StructuredListCell>*/}
															{/*						<StructuredListCell head>Trainer Name</StructuredListCell>*/}
															{/*						<StructuredListCell head>Signature</StructuredListCell>*/}
															{/*						<StructuredListCell head>Actions</StructuredListCell>*/}
															{/*					</StructuredListRow>*/}
															{/*				</StructuredListHead>*/}
															{/*				<StructuredListBody>*/}
															{/*					<StructuredListRow>*/}
															{/*						<StructuredListCell>{this.state.model.trainer && this.state.model.trainer.type}</StructuredListCell>*/}
															{/*						<StructuredListCell>{this.state.model.trainer && this.state.model.trainer.surname}</StructuredListCell>*/}
															{/*						<StructuredListCell>{this.state.model.trainer && this.state.model.trainer.name}</StructuredListCell>*/}
															{/*						<StructuredListCell className="signature-trainer">*/}
															{/*							{showModalSignature && this.state.model.trainer && this.state.model.trainer.signatureAttachment && (*/}
															{/*								<Checkmark24 fill="#1A3E4C" aria-label="" />*/}
															{/*							)}*/}
															{/*						</StructuredListCell>*/}
															{/*						<StructuredListCell className="signature-trainer">*/}
															{/*							{showModalSignature && !this.state.isDisabled && (*/}
															{/*								<Button*/}
															{/*									onClick={() => this.editTrainerSign()}*/}
															{/*									size="small"*/}
															{/*									className="bx--btn--icon-only"*/}
															{/*									renderIcon={PaintBrushAlt16}*/}
															{/*									iconDescription="Edit Signature"*/}
															{/*									title="Edit Signature"*/}
															{/*									kind="ghost"*/}
															{/*								/>*/}
															{/*							)}*/}
															{/*						</StructuredListCell>*/}
															{/*					</StructuredListRow>*/}
															{/*				</StructuredListBody>*/}
															{/*			</StructuredListWrapper>*/}
															{/*		</FormGroup>*/}
															{/*		<div>{validations.trainer}</div>*/}
															{/*	</div>*/}
															{/*</div>*/}
															{/*<ModalTrainer {...modalTrainerProps} />*/}
															{/*{showModalSignature && <ModalSignature {...modalSignatureProps} />}*/}
															{/*<div className="error-validation-message"></div>*/}
														</Section>
														<section>

															<div className="bx--row row-content">
																{!this.state.isEdit && this.state.model.reportingStyle != null && (
																	<div className="bx--col-lg-12 bx--col-md-12">
																		<TableToolbar>
																			<h3 className="title--medium max-width"></h3>
																			{!this.state.isDisabled && this.state.model.reportingType != null &&
																				this.state.model.reportingStyle == "Single" && this.state.model.startDate != null && this.state.model.endDate != null
																					&& this.state.model.trainingCourses.length < 1 && (
																					<Button
																						onClick={() => {
																							this.addTrainingCourse();
																						}}
																						renderIcon={Add16}
																					>
																						Add New Course
																					</Button>
																				)}
																		
																			{!this.state.isDisabled && this.state.model.reportingType != null &&
																				this.state.model.reportingType == "HSE" && this.state.model.reportingStyle == "Multiple"
																				&& this.state.model.startDate != null && this.state.model.endDate != null &&
																				this.state.model.trainingCourses.length < this.state.model.noOfCourses &&
																				(
																					<Button
																						onClick={() => {
																							this.addTrainingCourse();
																						}}
																						renderIcon={Add16}
																					>
																					Add New Course{this.state.model.trainingCourses.length < this.state.model.noOfCourses && ("(" + (parseInt(this.state.model.noOfCourses) - parseInt(this.state.model.trainingCourses.length))+")")}
																					</Button>
																				)}
																		</TableToolbar>
																		<TableContainer className="bx--grid--full-width">
																			<Table>
																				<TableHead className="colorgray">
																					<TableRow>
																						<TableHeader>Title</TableHeader>
																						<TableHeader>Actual Training Name</TableHeader>
																						<TableHeader>Language</TableHeader>
																						<TableHeader>Duration (hours)</TableHeader>
																						<TableHeader>Certificate Validity Period (Years)</TableHeader>

																						<TableHeader className="align-center">Actions</TableHeader>
																					</TableRow>
																				</TableHead>
																				<TableBody>
																					{this.renderTrainingCourses(trainingCourses)}
																				</TableBody>

																			</Table>
																		</TableContainer>
																	</div>
																)}
															</div>
															<ModalTrainingCourse {...modalTrainingCourseProps} />

															<div className="error-validation-message">

															</div>

														</section>
														{/*RITM0984969*/}
														<Section id="sec5">
															<div className="bx--row section--title">
																<div>
																	<h3 className="title--medium--expressive">Trainer Details</h3>
																</div>
															</div>
															<div className="bx--row row-content">
																<div className="bx--col-lg-12 bx--col-md-12">
																	<TableToolbar>
																		<h3 className="title--medium max-width"></h3>
																		{!this.state.isDisabled && (
																			this.state.model.trainingTrainer.length >= 0 &&
																			this.state.model.trainingTrainer.length < 4 &&

																			<Button
																				onClick={() => {
																					this.addTrainingTrainer();
																				}}
																				renderIcon={Add16}
																			>
																				Add New Trainer
																			</Button>
																		)}
																	</TableToolbar>
																	<TableContainer className="bx--grid--full-width">
																		<Table>
																			<TableHead className="colorgray">
																				<TableRow>
																					<TableHeader>Trainer Type</TableHeader>
																					<TableHeader>Trainer Surname</TableHeader>
																					<TableHeader>Trainer Name</TableHeader>
																					<TableHeader>Lead Trainer</TableHeader>
																					<TableHeader className="align-center">Signature</TableHeader>
																					<TableHeader className="align-center">Actions</TableHeader>
																				</TableRow>
																			</TableHead>
																			<TableBody>
																				<TableRow key="saipem" className="table-subtitle">
																					<TableCell colSpan={6}>INTERNAL</TableCell>
																				</TableRow>
																				{this.renderTrainers(true, trainingTrainers)}
																			</TableBody>

																			<TableBody>
																				<TableRow key="sub" className="table-subtitle">
																					<TableCell colSpan={6}>EXTERNAL</TableCell>
																				</TableRow>
																				{this.renderTrainers(false, trainingTrainers)}
																			</TableBody>
																		</Table>
																	</TableContainer>
																</div>
															</div>
															<ModalTrainer {...modalTrainingTrainerProps} />
															{modalTrainersSignatureProps.editModel && <ModalSignatureTrainer {...modalTrainersSignatureProps} />}
															<div className="error-validation-message">
																<div>{validations.trainerList}</div>
															</div>
														</Section>
														<Section id="sec2">
															<div className="bx--row section--title">
																{this.state.isEdit && (
																	<div>
																		{/*<h3 className="title--medium--expressive">Course Contents</h3>*/}
																		<h3 className="title--medium--expressive">Course Contents / Remarks</h3>
																	</div>
																)}
															</div>

															<div className="bx--row">
																{/* RITM0984969 */}
																{this.state.isEdit && (
																	<div className="bx--col-lg-12">
																		<TableToolbar>
																			<h3 className="title--medium max-width"></h3>
																			{!this.state.isDisabled && this.state.model.trainingContents.length < 1 &&(
																				<Button
																					onClick={() => {
																						this.addContent();
																					}}
																					renderIcon={Add16}
																				>
																					Add new
																				</Button>
																			)}
																		</TableToolbar>
																		<TableContainer className="bx--grid--full-width">
																			<Table>
																				<TableHead className="colorgray">
																					<TableRow>
																						<TableHeader>Content</TableHeader>
																						<TableHeader className="align-center">Actions</TableHeader>
																					</TableRow>
																				</TableHead>
																				<TableBody>
																					{trainingContents == null || trainingContents.length == 0 ? (
																						<NoRecordsPlaceholder labelText="No Records" colSpan={2} />
																					) : (
																						trainingContents.map((item, index) => (
																							<TableRow key={"row_" + item.id}>
																								<TableCell key={"cell_content_" + item.id}>{item.content && item.content.substr(0, 200)}</TableCell>
																								<TableCell key={"action-" + item.id} className="tableActions align-center">
																									{!this.state.isDisabled && (
																										<div>
																											<Button
																												onClick={() => this.editContent(item.id)}
																												size="small"
																												renderIcon={Edit16}
																												iconDescription="Edit"
																												title="Edit"
																												kind="ghost"
																											/>
																											<Button
																												onClick={() => this.confirmDeleteContent(item.id)}
																												size="small"
																												renderIcon={Delete16}
																												iconDescription="Delete"
																												title="Delete"
																												kind="ghost"
																											/>
																										</div>
																									)}
																								</TableCell>
																							</TableRow>
																						))
																					)}
																				</TableBody>
																			</Table>
																		</TableContainer>
																	</div>
																)}
															</div>
															<ModalContent {...modalContentProps} />
															<div className="error-validation-message"><div>{validations.contentList}</div></div>
														</Section>

														<Section id="sec3">
															<div className="bx--row section--title">
																<div>
																	
																			<h3 className="title--medium--expressive">Training Participant</h3>
																		
																	{this.state.model.reportingType != null
																		&& this.state.model.reportingType != 'HSE' && (
																		 <h5 className="blink" >
                   																			(If participants are from multiple worksites/projects, kindly indicate in the dedicated fields) </h5>
																		)}
																		</div>
															</div>

															<div className="bx--row">
																<div className="bx--col-lg-12">
																	<TableToolbar>
																		<Search
																			className=""
																			light
																			name=""
																			labelText="Search"
																			placeHolderText="Search"
																			id="search-1"
																			value={this.state.search || ""}
																			onChange={this.handleInputChange}
																		/>
																		{this.state.isEdit && (
																			<Online>
																				<FileDownLoadButton {...fileDownLoadAllProps} renderIcon={CertificateCheck16}>
																					Download All Certificates
																				</FileDownLoadButton>
																			</Online>
																		)}
																		<FileDownLoadButton
																			className="btn-notext"
																			onError={(error) => {
																				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAINING, apioperation.DOWNLOAD));
																			}}
																			renderIcon={Download16}
																			size="small"
																			title="Download Training Participant"
																			apiUrl={`/training/${this.state.model.id}/template`}
																			fileName="TrainingPartecipantTemplate.xlsx"
																			onDownLoadStart={() => {
																				this.setState({
																					downloadTemplateLoading: true,
																				});
																			}}
																			onDownLoadEnd={() => {
																				this.setState({
																					downloadTemplateLoading: false,
																				});
																			}}
																		>
																			{!this.state.downloadTemplateLoading ? '' : <Loading />}
																		</FileDownLoadButton>
																		{/* RITM0992772 - Participants Without Assessment For Submitted Training Fix */}
																		{/* {this.state.isEdit && (
																		<Button
																			className="btn-notext"
																			renderIcon={Export16}
																			size="small"
																			title="Import Training Participant"
																			onClick={() => this.toggleModalUploadTemplate(true)}
																			/>
																		)} */}
																		{/*{this.state.isEdit && !this.state.isDisabled && (*/}
																		{!this.state.isDisabled &&
																			this.state.model.reportingType != null
																			&& this.state.model.startDate != null && this.state.model.endDate != null && (
																			<Button
																				className="btn-notext"
																				renderIcon={Export16}
																				size="small"
																				title="Import Training Participant"
																				onClick={() => this.toggleModalUploadTemplate(true)}
																			/>
																		)}
																		{/* End */}

																		
																		{!this.state.isDisabled &&
																			this.state.model.reportingType != null
																			&& this.state.model.startDate != null && this.state.model.endDate != null && (
																			<Button
																				onClick={() => {
																					this.addParticipant();
																				}}
																				renderIcon={Add16}
																			>
																				Add new
																			</Button>
																			)}
																	</TableToolbar>
																	<TableContainer className="bx--grid--full-width">
																		<Table>
																			<TableHead className="colorgray">
																				<TableRow>
																					<TableHeader>S. No</TableHeader>
																					<TableHeader>Type</TableHeader>
																					{/*<TableHeader>Badge Number / Company</TableHeader>*/}
																					<TableHeader>Badge Number</TableHeader>
																					<TableHeader>Surname</TableHeader>
																					<TableHeader>Name</TableHeader>
																					{this.state.model.reportingType !== null
																						&& this.state.model.reportingType == 'HSE' && (<TableHeader colSpan={2}>Job Position</TableHeader>)}
																					{this.state.model.reportingType !== null
																						&& this.state.model.reportingType !== 'HSE' && (<TableHeader>WorkSite</TableHeader>)}
																					{this.state.model.reportingType !== null
																						&& this.state.model.reportingType !== 'HSE' && (<TableHeader>Project</TableHeader>)}
																					<TableHeader>Company</TableHeader>
																					<TableHeader>Assessment</TableHeader>
																					<TableHeader className="align-center">Signature</TableHeader>
																					<TableHeader className="align-center">Actions</TableHeader>
																				</TableRow>
																			</TableHead>
																			<TableBody>
																				<TableRow key="saipem" className="table-subtitle">
																					<TableCell colSpan={11}>SAIPEM PERSONNEL</TableCell>
																				</TableRow>
																				{this.renderParticipants(true, trainingParticipants)}
																			</TableBody>

																			<TableBody>
																				<TableRow key="sub" className="table-subtitle">
																					<TableCell colSpan={11}>(SUB) CONTRACTOR PERSONNEL / PARTNERS</TableCell>
																				</TableRow>
																				{this.renderParticipants(false, trainingParticipants)}
																			</TableBody>
																		</Table>
																	</TableContainer>
																</div>
															</div>
															<ModalParticipant {...modalParticipantProps} />
															{modalParticipantsSignatureProps.editModel && <ModalSignatureParticipant {...modalParticipantsSignatureProps} />}
															<div className="error-validation-message"></div>
														</Section>

														{/* RITM0562378 */}
														{this.state.isEdit && (
															<Section id="sec4" style={{ margin: "40px 0px" }}>

																<div className="bx--row section--title">

																	<div>
																		<h3 className="title--medium--expressive">Attachments</h3>
																	</div>
																</div>

																<AttachmentTable
																	storagePath="training"
																	acceptedFile={[".pdf"]}
																	model={this.state.model}
																	items={this.state.model?.attachments}
																	apiDownloadUrl={`/training/${this.state.idTraining}/attachment/`}
																	onUploadFIle={this.onUploadFiles}
																	onDeleteFile={this.onRemoveFile}
																	maxUploadDocument={1}
																	customMainDescription={TrainingAttachmentTableMainDescription}
																	customDescription={attachmentTablePrivacyText}
																	isDisabled={this.state.isDisabled}

																/>
																<div className="error-validation-message">
																	{/*<div>{validations.attachmentList}</div>*/}
																</div>
															</Section>
														)}
														{/* FINE RITM0562378 */}

													</div>
												</div>
												<div className="bx--row">
													<Button onClick={() => this.cancel()} className="bx--col bx--btn--max-width" size="default" kind="secondary">
														Cancel
													</Button>
													<Button onClick={() => this.saveTraining()} disabled={this.state.isDisabled} className="bx--col bx--btn--max-width" size="default" kind="primary">
														Save
													</Button>
													<Button onClick={() => window.print()} disabled={this.state.isDisabled} className="bx--col bx--btn--max-width" size="default" kind="secondary">
														Print
													</Button>
												</div>
											</ScrollingProvider>
										</div>
									</div>
								</form>
							</div>
						</div>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}

NewTraining.contextType = AppContext;
